import { Country } from '../types';

export const europeData: Country[] = [
  {
    "code": "AX",
    "name": "Aland Islands",
    "nameAr": "جزر أولاند",
    "nameFr": "Aland Islands",
    "cities": [
      {
        "name": "Brändö",
        "nameAr": "",
        "nameFr": "Brändö"
      },
      {
        "name": "Eckerö",
        "nameAr": "",
        "nameFr": "Eckerö"
      },
      {
        "name": "Finström",
        "nameAr": "",
        "nameFr": "Finström"
      },
      {
        "name": "Föglö",
        "nameAr": "",
        "nameFr": "Föglö"
      },
      {
        "name": "Geta",
        "nameAr": "",
        "nameFr": "Geta"
      },
      {
        "name": "Hammarland",
        "nameAr": "",
        "nameFr": "Hammarland"
      },
      {
        "name": "Jomala",
        "nameAr": "",
        "nameFr": "Jomala"
      },
      {
        "name": "Kökar",
        "nameAr": "",
        "nameFr": "Kökar"
      },
      {
        "name": "Kumlinge",
        "nameAr": "",
        "nameFr": "Kumlinge"
      },
      {
        "name": "Lemland",
        "nameAr": "",
        "nameFr": "Lemland"
      },
      {
        "name": "Lumparland",
        "nameAr": "",
        "nameFr": "Lumparland"
      },
      {
        "name": "Mariehamn",
        "nameAr": "",
        "nameFr": "Mariehamn"
      },
      {
        "name": "Saltvik",
        "nameAr": "",
        "nameFr": "Saltvik"
      },
      {
        "name": "Sottunga",
        "nameAr": "",
        "nameFr": "Sottunga"
      },
      {
        "name": "Sund",
        "nameAr": "",
        "nameFr": "Sund"
      },
      {
        "name": "Vårdö",
        "nameAr": "",
        "nameFr": "Vårdö"
      }
    ]
  },
  {
    "code": "AL",
    "name": "Albania",
    "nameAr": "ألبانيا",
    "nameFr": "Albania",
    "cities": [
      {
        "name": "Vlore",
        "nameAr": "فلور",
        "nameFr": "Vlore"
      },
      {
        "name": "Korce",
        "nameAr": "كورتشي",
        "nameFr": "Korce"
      },
      {
        "name": "Shkoder",
        "nameAr": "شكودر",
        "nameFr": "Shkoder"
      },
      {
        "name": "Durres",
        "nameAr": "دوريس",
        "nameFr": "Durres"
      },
      {
        "name": "Elbasan",
        "nameAr": "الباسان",
        "nameFr": "Elbasan"
      },
      {
        "name": "Kukes",
        "nameAr": "كوكس",
        "nameFr": "Kukes"
      },
      {
        "name": "Fier",
        "nameAr": "فيير",
        "nameFr": "Fier"
      },
      {
        "name": "Berat",
        "nameAr": "بيرات",
        "nameFr": "Berat"
      },
      {
        "name": "Gjirokaster",
        "nameAr": "جيروكاستر",
        "nameFr": "Gjirokaster"
      },
      {
        "name": "Tirane",
        "nameAr": "تيرانا",
        "nameFr": "Tirane"
      },
      {
        "name": "Lezhe",
        "nameAr": "ليج",
        "nameFr": "Lezhe"
      },
      {
        "name": "Diber",
        "nameAr": "ديبر",
        "nameFr": "Diber"
      }
    ]
  },
  {
    "code": "AD",
    "name": "Andorra",
    "nameAr": "أندورا",
    "nameFr": "Andorra",
    "cities": [
      {
        "name": "Sant Julia de Loria",
        "nameAr": "سانت جوليا دي لوريا",
        "nameFr": "Sant Julia de Loria"
      },
      {
        "name": "Andorra la Vella",
        "nameAr": "أندورا لا فيلا",
        "nameFr": "Andorra la Vella"
      },
      {
        "name": "La Massana",
        "nameAr": "لا ماسانا",
        "nameFr": "La Massana"
      },
      {
        "name": "Ordino",
        "nameAr": "أوردينو",
        "nameFr": "Ordino"
      },
      {
        "name": "Canillo",
        "nameAr": "كانيلو",
        "nameFr": "Canillo"
      },
      {
        "name": "Encamp",
        "nameAr": "نزلوا",
        "nameFr": "Camper"
      },
      {
        "name": "Escaldes-Engordany",
        "nameAr": "إسكالديس أنجوردني",
        "nameFr": "Escaldes-Engordany"
      }
    ]
  },
  {
    "code": "AT",
    "name": "Austria",
    "nameAr": "النمسا",
    "nameFr": "Austria",
    "cities": [
      {
        "name": "Burgenland",
        "nameAr": "",
        "nameFr": "Burgenland"
      },
      {
        "name": "Carinthia",
        "nameAr": "",
        "nameFr": "Carinthia"
      },
      {
        "name": "Lower Austria",
        "nameAr": "",
        "nameFr": "Lower Austria"
      },
      {
        "name": "Salzburg",
        "nameAr": "",
        "nameFr": "Salzburg"
      },
      {
        "name": "Styria",
        "nameAr": "",
        "nameFr": "Styria"
      },
      {
        "name": "Tyrol",
        "nameAr": "",
        "nameFr": "Tyrol"
      },
      {
        "name": "Upper Austria",
        "nameAr": "",
        "nameFr": "Upper Austria"
      },
      {
        "name": "Vienna",
        "nameAr": "",
        "nameFr": "Vienna"
      },
      {
        "name": "Vorarlberg",
        "nameAr": "",
        "nameFr": "Vorarlberg"
      }
    ]
  },
  {
    "code": "BY",
    "name": "Belarus",
    "nameAr": "روسيا البيضاء",
    "nameFr": "Belarus",
    "cities": [
      {
        "name": "Minsk",
        "nameAr": "مينسك",
        "nameFr": "Minsk"
      }
    ]
  },
  {
    "code": "BE",
    "name": "Belgium",
    "nameAr": "بلجيكا",
    "nameFr": "Belgium",
    "cities": [
      {
        "name": "Oost-Vlaanderen",
        "nameAr": "فلاندر الشرقية",
        "nameFr": "Oost-Vlaanderen"
      },
      {
        "name": "West-Vlaanderen",
        "nameAr": "فلاندر الغربية",
        "nameFr": "West-Vlaanderen"
      },
      {
        "name": "Limburg",
        "nameAr": "ليمبورغ",
        "nameFr": "Limbourg"
      },
      {
        "name": "Antwerpen",
        "nameAr": "أنتويرب",
        "nameFr": "Antwerpen"
      },
      {
        "name": "Luxembourg",
        "nameAr": "لوكسمبورغ",
        "nameFr": "Luxembourg"
      },
      {
        "name": "Hainaut",
        "nameAr": "ليمبورغ",
        "nameFr": "Hainaut"
      },
      {
        "name": "Liege",
        "nameAr": "مرتبط ب",
        "nameFr": "Lige"
      },
      {
        "name": "Namur",
        "nameAr": "نامور",
        "nameFr": "Namur"
      },
      {
        "name": "Brussels Hoofdstedelijk Gewest",
        "nameAr": "بروكسل Hoofdstedelijk Gewest",
        "nameFr": "Bruxelles Hoofdstedelijk Gewest"
      },
      {
        "name": "Vlaams-Brabant",
        "nameAr": "فلامس برابانت",
        "nameFr": "Brabant flamand"
      },
      {
        "name": "Brabant Wallon",
        "nameAr": "برابانت الوالون",
        "nameFr": "Brabant Wallon"
      }
    ]
  },
  {
    "code": "BA",
    "name": "Bosnia and Herzegovina",
    "nameAr": "البوسنة والهرسك",
    "nameFr": "Bosnia and Herzegovina",
    "cities": [
      {
        "name": "Republika Srpska",
        "nameAr": "جمهورية صربسكا",
        "nameFr": "Republika Srpska"
      },
      {
        "name": "Federation of Bosnia and Herzegovina",
        "nameAr": "اتحاد البوسنة والهرسك",
        "nameFr": "Fédération de Bosnie et Herzégovine"
      }
    ]
  },
  {
    "code": "BG",
    "name": "Bulgaria",
    "nameAr": "بلغاريا",
    "nameFr": "Bulgaria",
    "cities": [
      {
        "name": "Lovech",
        "nameAr": "لوفيتش",
        "nameFr": "Lovech"
      },
      {
        "name": "Varna",
        "nameAr": "فارنا",
        "nameFr": "Varna"
      },
      {
        "name": "Burgas",
        "nameAr": "بورغاس",
        "nameFr": "Burgas"
      },
      {
        "name": "Razgrad",
        "nameAr": "رازغراد",
        "nameFr": "Razgrad"
      },
      {
        "name": "Plovdiv",
        "nameAr": "بلوفديف",
        "nameFr": "Plovdiv"
      },
      {
        "name": "Khaskovo",
        "nameAr": "Khaskovo",
        "nameFr": "Khaskovo"
      },
      {
        "name": "Sofiya",
        "nameAr": "SOFIYA",
        "nameFr": "Sofiya"
      },
      {
        "name": "Silistra",
        "nameAr": "سيليسترا",
        "nameFr": "Silistra"
      },
      {
        "name": "Vidin",
        "nameAr": "فيدين",
        "nameFr": "Vidin"
      },
      {
        "name": "Montana",
        "nameAr": "مونتانا",
        "nameFr": "Montana"
      },
      {
        "name": "Mikhaylovgrad",
        "nameAr": "Mikhaylovgrad",
        "nameFr": "Mikhaylovgrad"
      },
      {
        "name": "Grad Sofiya",
        "nameAr": "جراد صوفيا",
        "nameFr": "Grad Sofiya"
      },
      {
        "name": "Turgovishte",
        "nameAr": "تارغوفيشته",
        "nameFr": "Turgovishte"
      },
      {
        "name": "Kurdzhali",
        "nameAr": "Kurdzhali",
        "nameFr": "Kurdzhali"
      },
      {
        "name": "Dobrich",
        "nameAr": "دوبريتش",
        "nameFr": "Dobrich"
      },
      {
        "name": "Shumen",
        "nameAr": "شومين",
        "nameFr": "Shumen"
      },
      {
        "name": "Blagoevgrad",
        "nameAr": "بلاغويفغارد",
        "nameFr": "Blagoevgrad"
      },
      {
        "name": "Smolyan",
        "nameAr": "سموليان",
        "nameFr": "Smolyan"
      },
      {
        "name": "Stara Zagora",
        "nameAr": "ستارا زاغورا",
        "nameFr": "Stara Zagora"
      },
      {
        "name": "Pazardzhik",
        "nameAr": "بازارجيك",
        "nameFr": "Pazardzhik"
      },
      {
        "name": "Ruse",
        "nameAr": "حيلة",
        "nameFr": "Ruse"
      },
      {
        "name": "Vratsa",
        "nameAr": "فراتسا",
        "nameFr": "Vratsa"
      },
      {
        "name": "Pleven",
        "nameAr": "بليفين",
        "nameFr": "Pleven"
      },
      {
        "name": "Pernik",
        "nameAr": "برنيك",
        "nameFr": "Pernik"
      },
      {
        "name": "Kyustendil",
        "nameAr": "كيوستينديل",
        "nameFr": "Kyustendil"
      },
      {
        "name": "Yambol",
        "nameAr": "يامبول",
        "nameFr": "Yambol"
      },
      {
        "name": "Gabrovo",
        "nameAr": "غابروفو",
        "nameFr": "Gabrovo"
      },
      {
        "name": "Sliven",
        "nameAr": "سليفن",
        "nameFr": "Sliven"
      },
      {
        "name": "Veliko Turnovo",
        "nameAr": "فيليكو ترنوفو",
        "nameFr": "Veliko Turnovo"
      }
    ]
  },
  {
    "code": "HR",
    "name": "Croatia",
    "nameAr": "كرواتيا",
    "nameFr": "Croatia",
    "cities": [
            {
                  "name": "Bjelovar-Bilogora",
                  "nameAr": "Bjelovar-Bilogora",
                  "nameFr": "Bjelovar-Bilogora"
            },
            {
                  "name": "Brod-Posavina",
                  "nameAr": "Brod-Posavina",
                  "nameFr": "Brod-Posavina"
            },
            {
                  "name": "Dubrovnik-Neretva",
                  "nameAr": "Dubrovnik-Neretva",
                  "nameFr": "Dubrovnik-Neretva"
            },
            {
                  "name": "Istria",
                  "nameAr": "Istrija",
                  "nameFr": "Istria"
            },
            {
                  "name": "Karlovac",
                  "nameAr": "Karlovac",
                  "nameFr": "Karlovac"
            },
            {
                  "name": "Koprivnica-Križevci",
                  "nameAr": "Koprivnica-Križevci",
                  "nameFr": "Koprivnica-Križevci"
            },
            {
                  "name": "Krapina-Zagorje",
                  "nameAr": "Krapina-Zagorje",
                  "nameFr": "Krapina-Zagorje"
            },
            {
                  "name": "Lika-Senj",
                  "nameAr": "Lika-Senj",
                  "nameFr": "Lika-Senj"
            },
            {
                  "name": "Međimurje",
                  "nameAr": "Međimurje",
                  "nameFr": "Međimurje"
            },
            {
                  "name": "Osijek-Baranja",
                  "nameAr": "Osijek-Baranja",
                  "nameFr": "Osijek-Baranja"
            },
            {
                  "name": "Požega-Slavonia",
                  "nameAr": "Požega-Slavonia",
                  "nameFr": "Požega-Slavonia"
            },
            {
                  "name": "Primorje-Gorski Kotar",
                  "nameAr": "Primorje-gorski kotar",
                  "nameFr": "Primorje-Gorski Kotar"
            },
            {
                  "name": "Šibenik-Knin",
                  "nameAr": "Šibenik-Knin",
                  "nameFr": "Šibenik-Knin"
            },
            {
                  "name": "Sisak-Moslavina",
                  "nameAr": "Sisak-Moslavina",
                  "nameFr": "Sisak-Moslavina"
            },
            {
                  "name": "Split-Dalmatia",
                  "nameAr": "Split-dalmacija",
                  "nameFr": "Split-Dalmatia"
            },
            {
                  "name": "Varaždin",
                  "nameAr": "Varaždin",
                  "nameFr": "Varaždin"
            },
            {
                  "name": "Virovitica-Podravina",
                  "nameAr": "Virovitica-Podravina",
                  "nameFr": "Virovitica-Podravina"
            },
            {
                  "name": "Vukovar-Syrmia",
                  "nameAr": "Vukovar-Sirmija",
                  "nameFr": "Vukovar-Syrmia"
            },
            {
                  "name": "Zadar",
                  "nameAr": "Zadar",
                  "nameFr": "Zadar"
            },
            {
                  "name": "Zagreb",
                  "nameAr": "Zagreb",
                  "nameFr": "Zagreb"
            },
            {
                  "name": "Zagreb",
                  "nameAr": "Zagreb",
                  "nameFr": "Zagreb"
            }
      ]
  },
  {
    "code": "CY",
    "name": "Cyprus",
    "nameAr": "قبرص",
    "nameFr": "Cyprus",
    "cities": [
      {
        "name": "Limassol",
        "nameAr": "ليماسول",
        "nameFr": "Limassol"
      },
      {
        "name": "Nicosia",
        "nameAr": "نيقوسيا",
        "nameFr": "Nicosie"
      },
      {
        "name": "Paphos",
        "nameAr": "بافوس",
        "nameFr": "Paphos"
      },
      {
        "name": "Famagusta",
        "nameAr": "فاماغوستا",
        "nameFr": "Famagusta"
      },
      {
        "name": "Larnaca",
        "nameAr": "لارنكا",
        "nameFr": "Larnaca"
      },
      {
        "name": "Kyrenia",
        "nameAr": "كيرينيا",
        "nameFr": "Kyrenia"
      }
    ]
  },
  {
    "code": "CZ",
    "name": "Czech Republic",
    "nameAr": "التشيك",
    "nameFr": "Czech Republic",
    "cities": [
      {
        "name": "Karlovarsky kraj",
        "nameAr": "كارلوفارسكي كراج",
        "nameFr": "Karlovarsky kraj"
      },
      {
        "name": "Pardubicky kraj",
        "nameAr": "بردوبيكي كراج",
        "nameFr": "Pardubicky kraj"
      },
      {
        "name": "Jihomoravsky kraj",
        "nameAr": "Jihomoravsky كراج",
        "nameFr": "Jihomoravsky kraj"
      },
      {
        "name": "Jihocesky kraj",
        "nameAr": "Jihocesky kraj",
        "nameFr": "Jihocesky kraj"
      },
      {
        "name": "Olomoucky kraj",
        "nameAr": "أولوموكي كراج",
        "nameFr": "Olomoucky kraj"
      },
      {
        "name": "Moravskoslezsky kraj",
        "nameAr": "Moravskoslezsky كراج",
        "nameFr": "Moravskoslezsky kraj"
      },
      {
        "name": "Kralovehradecky kraj",
        "nameAr": "Kralovehradecky كراج",
        "nameFr": "Kralovehradecky kraj"
      },
      {
        "name": "Ustecky kraj",
        "nameAr": "أوستيكي كراج",
        "nameFr": "Ustecky kraj"
      },
      {
        "name": "Stredocesky kraj",
        "nameAr": "Stredocesky كراج",
        "nameFr": "Stredocesky kraj"
      },
      {
        "name": "Vysocina",
        "nameAr": "فيسوسينا",
        "nameFr": "Vysocina"
      },
      {
        "name": "Plzensky kraj",
        "nameAr": "Plzensky كراج",
        "nameFr": "Kraj Plzensky"
      },
      {
        "name": "Zlinsky kraj",
        "nameAr": "زلينسكي كراج",
        "nameFr": "Zlinsky kraj"
      },
      {
        "name": "Hlavni mesto Praha",
        "nameAr": "هلفني ميستو براها",
        "nameFr": "Hlavni mesto Praha"
      },
      {
        "name": "Liberecky kraj",
        "nameAr": "Liberecky كراج",
        "nameFr": "Liberecky kraj"
      }
    ]
  },
  {
    "code": "DK",
    "name": "Denmark",
    "nameAr": "الدنمارك",
    "nameFr": "Denmark",
    "cities": [
      {
        "name": "Syddanmark",
        "nameAr": "سيدانمارك",
        "nameFr": "Syddanmark"
      },
      {
        "name": "Midtjylland",
        "nameAr": "ميتجيلاند",
        "nameFr": "Midtjylland"
      },
      {
        "name": "Nordjylland",
        "nameAr": "نوردلاند",
        "nameFr": "Nordjylland"
      },
      {
        "name": "Sjelland",
        "nameAr": "Sjelland",
        "nameFr": "Sjelland"
      },
      {
        "name": "Hovedstaden",
        "nameAr": "هوفدستادين",
        "nameFr": "Hovedstaden"
      }
    ]
  },
  {
    "code": "EE",
    "name": "Estonia",
    "nameAr": "إستونيا",
    "nameFr": "Estonia",
    "cities": [
      {
        "name": "Harjumaa",
        "nameAr": "Harjumaa",
        "nameFr": "Harjumaa"
      },
      {
        "name": "Tartumaa",
        "nameAr": "تارتوما",
        "nameFr": "Tartumaa"
      },
      {
        "name": "Hiiumaa",
        "nameAr": "هيوما",
        "nameFr": "Hiiumaa"
      },
      {
        "name": "Raplamaa",
        "nameAr": "رابلاما",
        "nameFr": "Raplamaa"
      },
      {
        "name": "Valgamaa",
        "nameAr": "فلغما",
        "nameFr": "Valgamaa"
      },
      {
        "name": "Laanemaa",
        "nameAr": "انيما",
        "nameFr": "Laanemaa"
      },
      {
        "name": "Polvamaa",
        "nameAr": "بولفاما",
        "nameFr": "Polvamaa"
      },
      {
        "name": "Parnumaa",
        "nameAr": "بارنوما",
        "nameFr": "Parnumaa"
      },
      {
        "name": "Laane-Virumaa",
        "nameAr": "اني فيريوما",
        "nameFr": "Laane-Virumaa"
      },
      {
        "name": "Jarvamaa",
        "nameAr": "يارفا",
        "nameFr": "Jarvamaa"
      },
      {
        "name": "Viljandimaa",
        "nameAr": "فيلجاندي",
        "nameFr": "Viljandimaa"
      },
      {
        "name": "Saaremaa",
        "nameAr": "ساريما",
        "nameFr": "Saaremaa"
      },
      {
        "name": "Jogevamaa",
        "nameAr": "جوغفما",
        "nameFr": "Jogevamaa"
      },
      {
        "name": "Ida-Virumaa",
        "nameAr": "المؤسسة الدولية للتنمية فيروما",
        "nameFr": "Ida-Virumaa"
      },
      {
        "name": "Vorumaa",
        "nameAr": "فوروما",
        "nameFr": "Vorumaa"
      }
    ]
  },
  {
    "code": "FO",
    "name": "Faroe Islands",
    "nameAr": "جزر فارو",
    "nameFr": "Faroe Islands",
    "cities": [
            {
                  "name": "Andorra la Vella",
                  "nameAr": "Andorra la Vella",
                  "nameFr": "Andorra la Vella"
            },
            {
                  "name": "Canillo",
                  "nameAr": "Canillo",
                  "nameFr": "Canillo"
            },
            {
                  "name": "Encamp",
                  "nameAr": "Encamp",
                  "nameFr": "Encamp"
            },
            {
                  "name": "Escaldes-Engordany",
                  "nameAr": "Escaldes-Engordany",
                  "nameFr": "Escaldes-Engordany"
            },
            {
                  "name": "La Massana",
                  "nameAr": "La Massana",
                  "nameFr": "La Massana"
            },
            {
                  "name": "Ordino",
                  "nameAr": "Ordino",
                  "nameFr": "Ordino"
            },
            {
                  "name": "Sant Julià de Lòria",
                  "nameAr": "Sant Julià de Lòria",
                  "nameFr": "Sant Julià de Lòria"
            }
      ]
  },
  {
    "code": "FI",
    "name": "Finland",
    "nameAr": "فنلندا",
    "nameFr": "Finland",
    "cities": [
      {
        "name": "Oulu",
        "nameAr": "أولو",
        "nameFr": "Oulu"
      },
      {
        "name": "Western Finland",
        "nameAr": "فنلندا الغربية",
        "nameFr": "Finlande occidentale"
      },
      {
        "name": "Lapland",
        "nameAr": "ابلاند",
        "nameFr": "Laponie"
      },
      {
        "name": "Eastern Finland",
        "nameAr": "شرق فنلندا",
        "nameFr": "Finlande orientale"
      },
      {
        "name": "Southern Finland",
        "nameAr": "جنوب فنلندا",
        "nameFr": "Finlande méridionale"
      },
      {
        "name": "Aland",
        "nameAr": "أرض",
        "nameFr": "Un terrain"
      }
    ]
  },
  {
    "code": "FR",
    "name": "France",
    "nameAr": "فرنسا",
    "nameFr": "France",
    "cities": [
      {
        "name": "Aquitaine",
        "nameAr": "آكيتن",
        "nameFr": "Aquitaine"
      },
      {
        "name": "Nord-Pas-de-Calais",
        "nameAr": "نور-با-دو-كاليه",
        "nameFr": "Nord-Pas-de-Calais"
      },
      {
        "name": "Lorraine",
        "nameAr": "لورين",
        "nameFr": "Lorraine"
      },
      {
        "name": "Haute-Normandie",
        "nameAr": "هوت نورماندي",
        "nameFr": "Haute-Normandie"
      },
      {
        "name": "Picardie",
        "nameAr": "بيكاردي",
        "nameFr": "Picardie"
      },
      {
        "name": "Franche-Comte",
        "nameAr": "فرانش-كونت",
        "nameFr": "Franche-Comté"
      },
      {
        "name": "Pays de la Loire",
        "nameAr": "باي دو لا لوار",
        "nameFr": "Pays de la Loire"
      },
      {
        "name": "Champagne-Ardenne",
        "nameAr": "الشمبانيا اردين",
        "nameFr": "Champagne-Ardenne"
      },
      {
        "name": "Centre",
        "nameAr": "مركز",
        "nameFr": "Centre"
      },
      {
        "name": "Languedoc-Roussillon",
        "nameAr": "لانغدوك روسيون",
        "nameFr": "Languedoc-Roussillon"
      },
      {
        "name": "Poitou-Charentes",
        "nameAr": "بواتو-شارانت",
        "nameFr": "Poitou-Charentes"
      },
      {
        "name": "Rhone-Alpes",
        "nameAr": "رون ألب",
        "nameFr": "Rhône-Alpes"
      },
      {
        "name": "Basse-Normandie",
        "nameAr": "باس نورماندي",
        "nameFr": "Basse-Normandie"
      },
      {
        "name": "Ile-de-France",
        "nameAr": "إيل دو فرانس",
        "nameFr": "Ile de France"
      },
      {
        "name": "Bourgogne",
        "nameAr": "بورغون",
        "nameFr": "Bourgogne"
      },
      {
        "name": "Auvergne",
        "nameAr": "أوفيرني",
        "nameFr": "Auvergne"
      },
      {
        "name": "Corse",
        "nameAr": "كورس",
        "nameFr": "Corse"
      },
      {
        "name": "Alsace",
        "nameAr": "الألزاس",
        "nameFr": "Alsace"
      },
      {
        "name": "Bretagne",
        "nameAr": "بريتان",
        "nameFr": "Bretagne"
      },
      {
        "name": "Midi-Pyrenees",
        "nameAr": "ميدي-بيرينيه",
        "nameFr": "Midi-Pyrénées"
      },
      {
        "name": "Limousin",
        "nameAr": "ليموزين",
        "nameFr": "Limousin"
      }
    ]
  },
  {
    "code": "DE",
    "name": "Germany",
    "nameAr": "ألمانيا",
    "nameFr": "Germany",
    "cities": [
      {
        "name": "Nordrhein-Westfalen",
        "nameAr": "نوردراين فيستفالن",
        "nameFr": "Nordrhein-Westfalen"
      },
      {
        "name": "Baden-Wurttemberg",
        "nameAr": "بادن فورتمبيرغ",
        "nameFr": "Bade-Wurtemberg"
      },
      {
        "name": "Bayern",
        "nameAr": "بايرن ميونيخ",
        "nameFr": "Bayern"
      },
      {
        "name": "Rheinland-Pfalz",
        "nameAr": "راينلاند-بفالز",
        "nameFr": "Rheinland-Pfalz"
      },
      {
        "name": "Niedersachsen",
        "nameAr": "Niedersachsen",
        "nameFr": "Niedersachsen"
      },
      {
        "name": "Schleswig-Holstein",
        "nameAr": "شليسفيغ هولشتاين",
        "nameFr": "Schleswig-Holstein"
      },
      {
        "name": "Brandenburg",
        "nameAr": "براندنبورغ",
        "nameFr": "Brandebourg"
      },
      {
        "name": "Sachsen-Anhalt",
        "nameAr": "سكسونيا أنهالت",
        "nameFr": "Sachsen-Anhalt"
      },
      {
        "name": "Sachsen",
        "nameAr": "ساكسن",
        "nameFr": "Sachsen"
      },
      {
        "name": "Thuringen",
        "nameAr": "THÜRINGEN",
        "nameFr": "Thuringen"
      },
      {
        "name": "Hessen",
        "nameAr": "هيسن",
        "nameFr": "Hesse"
      },
      {
        "name": "Mecklenburg-Vorpommern",
        "nameAr": "مكلنبورغ-فوربومرن",
        "nameFr": "Mecklembourg-Poméranie-Occidentale"
      },
      {
        "name": "Hamburg",
        "nameAr": "هامبورغ",
        "nameFr": "Hambourg"
      },
      {
        "name": "Berlin",
        "nameAr": "البرلينية",
        "nameFr": "Berlin"
      },
      {
        "name": "Saarland",
        "nameAr": "سارلاند",
        "nameFr": "Sarre"
      },
      {
        "name": "Bremen",
        "nameAr": "بريمن",
        "nameFr": "Brême"
      }
    ]
  },
  {
    "code": "GI",
    "name": "Gibraltar",
    "nameAr": "جبل طارق",
    "nameFr": "Gibraltar",
    "cities": []
  },
  {
    "code": "GR",
    "name": "Greece",
    "nameAr": "اليونان",
    "nameFr": "Greece",
    "cities": [
            {
                  "name": "Achaea",
                  "nameAr": "Αχαία",
                  "nameFr": "Achaea"
            },
            {
                  "name": "Aetolia-Acarnania",
                  "nameAr": "Αιθολία-ακαρνία",
                  "nameFr": "Aetolia-Acarnania"
            },
            {
                  "name": "Arcadia",
                  "nameAr": "Αρκάδια",
                  "nameFr": "Arcadia"
            },
            {
                  "name": "Argolis",
                  "nameAr": "Αργολίδα",
                  "nameFr": "Argolis"
            },
            {
                  "name": "Attica",
                  "nameAr": "Αττική",
                  "nameFr": "Attica"
            },
            {
                  "name": "Boeotia",
                  "nameAr": "Βοιωτία",
                  "nameFr": "Boeotia"
            },
            {
                  "name": "Central Greece",
                  "nameAr": "Κεντρική Ελλάδα",
                  "nameFr": "Central Greece"
            },
            {
                  "name": "Central Macedonia",
                  "nameAr": "Central Macedonia",
                  "nameFr": "Central Macedonia"
            },
            {
                  "name": "Chania",
                  "nameAr": "Chania",
                  "nameFr": "Chania"
            },
            {
                  "name": "Corfu",
                  "nameAr": "Κέρκυρα",
                  "nameFr": "Corfu"
            },
            {
                  "name": "Corinthia",
                  "nameAr": "Κορινθία",
                  "nameFr": "Corinthia"
            },
            {
                  "name": "Crete",
                  "nameAr": "Crete",
                  "nameFr": "Crete"
            },
            {
                  "name": "Drama",
                  "nameAr": "Δράμα",
                  "nameFr": "Drama"
            },
            {
                  "name": "East Attica",
                  "nameAr": "Ανατολική Αττική",
                  "nameFr": "East Attica"
            },
            {
                  "name": "East Macedonia and Thrace",
                  "nameAr": "Ανατολική Μακεδονία και Θράκη",
                  "nameFr": "East Macedonia and Thrace"
            },
            {
                  "name": "Epirus",
                  "nameAr": "Ήπειρος",
                  "nameFr": "Epirus"
            },
            {
                  "name": "Euboea",
                  "nameAr": "Εύβοια",
                  "nameFr": "Euboea"
            },
            {
                  "name": "Grevena",
                  "nameAr": "Grevena",
                  "nameFr": "Grevena"
            },
            {
                  "name": "Imathia ",
                  "nameAr": "Imathia",
                  "nameFr": "Imathia "
            },
            {
                  "name": "Ioannina",
                  "nameAr": "Noconicia Hula.",
                  "nameFr": "Ioannina"
            },
            {
                  "name": "Ionian Islands",
                  "nameAr": "Επτάνησα",
                  "nameFr": "Ionian Islands"
            },
            {
                  "name": "Karditsa",
                  "nameAr": "Karditsa",
                  "nameFr": "Karditsa"
            },
            {
                  "name": "Kastoria",
                  "nameAr": "Kastoria",
                  "nameFr": "Kastoria"
            },
            {
                  "name": "Kefalonia",
                  "nameAr": "Ακαλονία",
                  "nameFr": "Kefalonia"
            },
            {
                  "name": "Kilkis",
                  "nameAr": "Kilkis",
                  "nameFr": "Kilkis"
            },
            {
                  "name": "Kozani",
                  "nameAr": "Κοζάνι",
                  "nameFr": "Kozani"
            },
            {
                  "name": "Laconia",
                  "nameAr": "Λακωνία",
                  "nameFr": "Laconia"
            },
            {
                  "name": "Larissa",
                  "nameAr": "Λάρισα",
                  "nameFr": "Larissa"
            },
            {
                  "name": "Lefkada",
                  "nameAr": "Λεφκαάδα",
                  "nameFr": "Lefkada"
            },
            {
                  "name": "Pella",
                  "nameAr": "Πέλλα",
                  "nameFr": "Pella"
            },
            {
                  "name": "Peloponnese",
                  "nameAr": "Πελοπόννησος",
                  "nameFr": "Peloponnese"
            },
            {
                  "name": "Phthiotis",
                  "nameAr": "Φθοότης",
                  "nameFr": "Phthiotis"
            },
            {
                  "name": "Preveza",
                  "nameAr": "Λεία",
                  "nameFr": "Preveza"
            },
            {
                  "name": "Serres",
                  "nameAr": "Θερμοκήπια",
                  "nameFr": "Serres"
            },
            {
                  "name": "South Aegean",
                  "nameAr": "Νότιο Αιγαίο",
                  "nameFr": "South Aegean"
            },
            {
                  "name": "Thessaloniki",
                  "nameAr": "Θεσσαλονίκη",
                  "nameFr": "Thessaloniki"
            },
            {
                  "name": "West Greece",
                  "nameAr": "West Greece",
                  "nameFr": "West Greece"
            },
            {
                  "name": "West Macedonia",
                  "nameAr": "Δυτική Μακεδονία",
                  "nameFr": "West Macedonia"
            }
      ]
  },
  {
    "code": "GG",
    "name": "Guernsey",
    "nameAr": "غيرنزي",
    "nameFr": "Guernsey",
    "cities": [
            {
                  "name": "Ain",
                  "nameAr": "Se faire",
                  "nameFr": "Ain"
            },
            {
                  "name": "Aisne",
                  "nameAr": "Aisne",
                  "nameFr": "Aisne"
            },
            {
                  "name": "Allier",
                  "nameAr": "Allier",
                  "nameFr": "Allier"
            },
            {
                  "name": "Alpes-de-Haute-Provence",
                  "nameAr": "Alpes-de-Haute-Provence",
                  "nameFr": "Alpes-de-Haute-Provence"
            },
            {
                  "name": "Alpes-Maritimes",
                  "nameAr": "Alpes-Maritimes",
                  "nameFr": "Alpes-Maritimes"
            },
            {
                  "name": "Alsace",
                  "nameAr": "Alsace",
                  "nameFr": "Alsace"
            },
            {
                  "name": "Ardèche",
                  "nameAr": "Ardèche",
                  "nameFr": "Ardèche"
            },
            {
                  "name": "Ardennes",
                  "nameAr": "Ardennes",
                  "nameFr": "Ardennes"
            },
            {
                  "name": "Ariège",
                  "nameAr": "Ariège",
                  "nameFr": "Ariège"
            },
            {
                  "name": "Aube",
                  "nameAr": "Aube",
                  "nameFr": "Aube"
            },
            {
                  "name": "Aude",
                  "nameAr": "entendus",
                  "nameFr": "Aude"
            },
            {
                  "name": "Auvergne-Rhône-Alpes",
                  "nameAr": "Auvergne-Rhône-Alpes",
                  "nameFr": "Auvergne-Rhône-Alpes"
            },
            {
                  "name": "Aveyron",
                  "nameAr": "Aveyron",
                  "nameFr": "Aveyron"
            },
            {
                  "name": "Bas-Rhin",
                  "nameAr": "Bas-Rhin",
                  "nameFr": "Bas-Rhin"
            },
            {
                  "name": "Bouches-du-Rhône",
                  "nameAr": "Bouches-du-Rhône",
                  "nameFr": "Bouches-du-Rhône"
            },
            {
                  "name": "Bourgogne-Franche-Comté",
                  "nameAr": "Bourgogne-Franche-Comté",
                  "nameFr": "Bourgogne-Franche-Comté"
            },
            {
                  "name": "Bretagne",
                  "nameAr": "Bretagne",
                  "nameFr": "Bretagne"
            },
            {
                  "name": "Calvados",
                  "nameAr": "Calvados",
                  "nameFr": "Calvados"
            },
            {
                  "name": "Cantal",
                  "nameAr": "Cantal",
                  "nameFr": "Cantal"
            },
            {
                  "name": "Centre-Val de Loire",
                  "nameAr": "Centre-Val de Loire",
                  "nameFr": "Centre-Val de Loire"
            },
            {
                  "name": "Charente",
                  "nameAr": "Charente",
                  "nameFr": "Charente"
            },
            {
                  "name": "Charente-Maritime",
                  "nameAr": "Charente-Maritime",
                  "nameFr": "Charente-Maritime"
            },
            {
                  "name": "Cher",
                  "nameAr": "Cher",
                  "nameFr": "Cher"
            },
            {
                  "name": "Clipperton",
                  "nameAr": "Clipperton",
                  "nameFr": "Clipperton"
            },
            {
                  "name": "Corrèze",
                  "nameAr": "Corrèze",
                  "nameFr": "Corrèze"
            },
            {
                  "name": "Corse",
                  "nameAr": "Corsée",
                  "nameFr": "Corse"
            },
            {
                  "name": "Corse-du-Sud",
                  "nameAr": "Corse-du-Sud",
                  "nameFr": "Corse-du-Sud"
            },
            {
                  "name": "Côte-d'Or",
                  "nameAr": "Côte-d'Or",
                  "nameFr": "Côte-d'Or"
            },
            {
                  "name": "Côtes-d'Armor",
                  "nameAr": "Côtes-d'Armor",
                  "nameFr": "Côtes-d'Armor"
            },
            {
                  "name": "Creuse",
                  "nameAr": "Creuse",
                  "nameFr": "Creuse"
            },
            {
                  "name": "Deux-Sèvres",
                  "nameAr": "Deux-Sèvres",
                  "nameFr": "Deux-Sèvres"
            },
            {
                  "name": "Dordogne",
                  "nameAr": "Dordogne",
                  "nameFr": "Dordogne"
            },
            {
                  "name": "Doubs",
                  "nameAr": "Doubs",
                  "nameFr": "Doubs"
            },
            {
                  "name": "Drôme",
                  "nameAr": "Drôme",
                  "nameFr": "Drôme"
            },
            {
                  "name": "Essonne",
                  "nameAr": "Essonne",
                  "nameFr": "Essonne"
            },
            {
                  "name": "Eure",
                  "nameAr": "Ton",
                  "nameFr": "Eure"
            },
            {
                  "name": "Eure-et-Loir",
                  "nameAr": "Eure-et-Loir",
                  "nameFr": "Eure-et-Loir"
            },
            {
                  "name": "Finistère",
                  "nameAr": "Finistère",
                  "nameFr": "Finistère"
            },
            {
                  "name": "French Guiana",
                  "nameAr": "French Guiana",
                  "nameFr": "French Guiana"
            },
            {
                  "name": "French Polynesia",
                  "nameAr": "Polynésie française",
                  "nameFr": "French Polynesia"
            },
            {
                  "name": "French Southern and Antarctic Lands",
                  "nameAr": "Terres du sud et de l'Antarctique français",
                  "nameFr": "French Southern and Antarctic Lands"
            },
            {
                  "name": "Gard",
                  "nameAr": "Gardien",
                  "nameFr": "Gard"
            },
            {
                  "name": "Gers",
                  "nameAr": "Génie",
                  "nameFr": "Gers"
            },
            {
                  "name": "Gironde",
                  "nameAr": "Gironde",
                  "nameFr": "Gironde"
            },
            {
                  "name": "Grand-Est",
                  "nameAr": "Grand-Est",
                  "nameFr": "Grand-Est"
            },
            {
                  "name": "Guadeloupe",
                  "nameAr": "Guadeloupe",
                  "nameFr": "Guadeloupe"
            },
            {
                  "name": "Haut-Rhin",
                  "nameAr": "Peau",
                  "nameFr": "Haut-Rhin"
            },
            {
                  "name": "Haute-Corse",
                  "nameAr": "Haute-Corse",
                  "nameFr": "Haute-Corse"
            },
            {
                  "name": "Haute-Garonne",
                  "nameAr": "Haute-Garonne",
                  "nameFr": "Haute-Garonne"
            },
            {
                  "name": "Haute-Loire",
                  "nameAr": "Haute-Loire",
                  "nameFr": "Haute-Loire"
            },
            {
                  "name": "Haute-Marne",
                  "nameAr": "Haute-Marne",
                  "nameFr": "Haute-Marne"
            },
            {
                  "name": "Haute-Saône",
                  "nameAr": "Haute-Saône",
                  "nameFr": "Haute-Saône"
            },
            {
                  "name": "Haute-Savoie",
                  "nameAr": "Haute-Savoie",
                  "nameFr": "Haute-Savoie"
            },
            {
                  "name": "Haute-Vienne",
                  "nameAr": "Haute-Vienne",
                  "nameFr": "Haute-Vienne"
            },
            {
                  "name": "Hautes-Alpes",
                  "nameAr": "Hautes-Alpes",
                  "nameFr": "Hautes-Alpes"
            },
            {
                  "name": "Hautes-Pyrénées",
                  "nameAr": "Hautes-Pyrénées",
                  "nameFr": "Hautes-Pyrénées"
            },
            {
                  "name": "Hauts-de-France",
                  "nameAr": "Hauts-de-France",
                  "nameFr": "Hauts-de-France"
            },
            {
                  "name": "Hauts-de-Seine",
                  "nameAr": "Hauts-de-Seine",
                  "nameFr": "Hauts-de-Seine"
            },
            {
                  "name": "Hérault",
                  "nameAr": "Hérault",
                  "nameFr": "Hérault"
            },
            {
                  "name": "Île-de-France",
                  "nameAr": "Île-de-France",
                  "nameFr": "Île-de-France"
            },
            {
                  "name": "Ille-et-Vilaine",
                  "nameAr": "Ille-et-Vilaine",
                  "nameFr": "Ille-et-Vilaine"
            },
            {
                  "name": "Indre",
                  "nameAr": "Interne",
                  "nameFr": "Indre"
            },
            {
                  "name": "Indre-et-Loire",
                  "nameAr": "Indre-et-Loire",
                  "nameFr": "Indre-et-Loire"
            },
            {
                  "name": "Isère",
                  "nameAr": "Isère",
                  "nameFr": "Isère"
            },
            {
                  "name": "Jura",
                  "nameAr": "Jura",
                  "nameFr": "Jura"
            },
            {
                  "name": "La Réunion",
                  "nameAr": "La Réunion",
                  "nameFr": "La Réunion"
            },
            {
                  "name": "Landes",
                  "nameAr": "Landes",
                  "nameFr": "Landes"
            },
            {
                  "name": "Loir-et-Cher",
                  "nameAr": "Loir-et-Cher",
                  "nameFr": "Loir-et-Cher"
            },
            {
                  "name": "Loire",
                  "nameAr": "Loire",
                  "nameFr": "Loire"
            },
            {
                  "name": "Loire-Atlantique",
                  "nameAr": "Loire-Atlantique",
                  "nameFr": "Loire-Atlantique"
            },
            {
                  "name": "Loiret",
                  "nameAr": "Loiret",
                  "nameFr": "Loiret"
            },
            {
                  "name": "Lot",
                  "nameAr": "Parcelle",
                  "nameFr": "Lot"
            },
            {
                  "name": "Lot-et-Garonne",
                  "nameAr": "Lot-et-Garonne",
                  "nameFr": "Lot-et-Garonne"
            },
            {
                  "name": "Lozère",
                  "nameAr": "Lozère",
                  "nameFr": "Lozère"
            },
            {
                  "name": "Maine-et-Loire",
                  "nameAr": "Maine-et-Loire",
                  "nameFr": "Maine-et-Loire"
            },
            {
                  "name": "Manche",
                  "nameAr": "Quelques",
                  "nameFr": "Manche"
            },
            {
                  "name": "Marne",
                  "nameAr": "Marne",
                  "nameFr": "Marne"
            },
            {
                  "name": "Martinique",
                  "nameAr": "Martinique",
                  "nameFr": "Martinique"
            },
            {
                  "name": "Mayenne",
                  "nameAr": "Mayenne",
                  "nameFr": "Mayenne"
            },
            {
                  "name": "Mayotte",
                  "nameAr": "Mayotte",
                  "nameFr": "Mayotte"
            },
            {
                  "name": "Métropole de Lyon",
                  "nameAr": "Métropole de Lyon",
                  "nameFr": "Métropole de Lyon"
            },
            {
                  "name": "Meurthe-et-Moselle",
                  "nameAr": "Meurthe-et-Moselle",
                  "nameFr": "Meurthe-et-Moselle"
            },
            {
                  "name": "Meuse",
                  "nameAr": "Miuse",
                  "nameFr": "Meuse"
            },
            {
                  "name": "Morbihan",
                  "nameAr": "Morbihan",
                  "nameFr": "Morbihan"
            },
            {
                  "name": "Moselle",
                  "nameAr": "Moselle",
                  "nameFr": "Moselle"
            },
            {
                  "name": "Nièvre",
                  "nameAr": "Nièvre",
                  "nameFr": "Nièvre"
            },
            {
                  "name": "Nord",
                  "nameAr": "Nord",
                  "nameFr": "Nord"
            },
            {
                  "name": "Normandie",
                  "nameAr": "Normandie",
                  "nameFr": "Normandie"
            },
            {
                  "name": "Nouvelle-Aquitaine",
                  "nameAr": "Nouvelle-Aquitaine",
                  "nameFr": "Nouvelle-Aquitaine"
            },
            {
                  "name": "Occitanie",
                  "nameAr": "Occitanie",
                  "nameFr": "Occitanie"
            },
            {
                  "name": "Oise",
                  "nameAr": "Oise",
                  "nameFr": "Oise"
            },
            {
                  "name": "Orne",
                  "nameAr": "Orne",
                  "nameFr": "Orne"
            },
            {
                  "name": "Paris",
                  "nameAr": "Paris",
                  "nameFr": "Paris"
            },
            {
                  "name": "Pas-de-Calais",
                  "nameAr": "Pas-de-Calais",
                  "nameFr": "Pas-de-Calais"
            },
            {
                  "name": "Pays-de-la-Loire",
                  "nameAr": "Pays-de-la-Loire",
                  "nameFr": "Pays-de-la-Loire"
            },
            {
                  "name": "Provence-Alpes-Côte-d’Azur",
                  "nameAr": "Provence-Alpes-Côte-d’Azur",
                  "nameFr": "Provence-Alpes-Côte-d’Azur"
            },
            {
                  "name": "Puy-de-Dôme",
                  "nameAr": "Puy-de-Dôme",
                  "nameFr": "Puy-de-Dôme"
            },
            {
                  "name": "Pyrénées-Atlantiques",
                  "nameAr": "Pyrénées-Atlantiques",
                  "nameFr": "Pyrénées-Atlantiques"
            },
            {
                  "name": "Pyrénées-Orientales",
                  "nameAr": "Pyrénées-Orientales",
                  "nameFr": "Pyrénées-Orientales"
            },
            {
                  "name": "Rhône",
                  "nameAr": "Rhône",
                  "nameFr": "Rhône"
            },
            {
                  "name": "Saint Pierre and Miquelon",
                  "nameAr": "Saint Pierre and Miquelon",
                  "nameFr": "Saint Pierre and Miquelon"
            },
            {
                  "name": "Saint-Barthélemy",
                  "nameAr": "Saint-Barthélemy",
                  "nameFr": "Saint-Barthélemy"
            },
            {
                  "name": "Saint-Martin",
                  "nameAr": "Saint-Martin",
                  "nameFr": "Saint-Martin"
            },
            {
                  "name": "Saône-et-Loire",
                  "nameAr": "Saône-et-Loire",
                  "nameFr": "Saône-et-Loire"
            },
            {
                  "name": "Sarthe",
                  "nameAr": "Sarthe",
                  "nameFr": "Sarthe"
            },
            {
                  "name": "Savoie",
                  "nameAr": "Savoie",
                  "nameFr": "Savoie"
            },
            {
                  "name": "Seine-et-Marne",
                  "nameAr": "Seine-et-Marne",
                  "nameFr": "Seine-et-Marne"
            },
            {
                  "name": "Seine-Maritime",
                  "nameAr": "Seine-Maritime",
                  "nameFr": "Seine-Maritime"
            },
            {
                  "name": "Seine-Saint-Denis",
                  "nameAr": "Seine-Saint-Denis",
                  "nameFr": "Seine-Saint-Denis"
            },
            {
                  "name": "Somme",
                  "nameAr": "Somme",
                  "nameFr": "Somme"
            },
            {
                  "name": "Tarn",
                  "nameAr": "Tarn",
                  "nameFr": "Tarn"
            },
            {
                  "name": "Tarn-et-Garonne",
                  "nameAr": "Tarn-et-Garonne",
                  "nameFr": "Tarn-et-Garonne"
            },
            {
                  "name": "Territoire de Belfort",
                  "nameAr": "Territoire de Belfort",
                  "nameFr": "Territoire de Belfort"
            },
            {
                  "name": "Val-d'Oise",
                  "nameAr": "Val-d'Oise",
                  "nameFr": "Val-d'Oise"
            },
            {
                  "name": "Val-de-Marne",
                  "nameAr": "Val-de-Marne",
                  "nameFr": "Val-de-Marne"
            },
            {
                  "name": "Var",
                  "nameAr": "Notre",
                  "nameFr": "Var"
            },
            {
                  "name": "Vaucluse",
                  "nameAr": "Vaucluse",
                  "nameFr": "Vaucluse"
            },
            {
                  "name": "Vendée",
                  "nameAr": "Vendée",
                  "nameFr": "Vendée"
            },
            {
                  "name": "Vienne",
                  "nameAr": "Vienne",
                  "nameFr": "Vienne"
            },
            {
                  "name": "Vosges",
                  "nameAr": "Vosges",
                  "nameFr": "Vosges"
            },
            {
                  "name": "Wallis and Futuna",
                  "nameAr": "Wallis et Futuna",
                  "nameFr": "Wallis and Futuna"
            },
            {
                  "name": "Yonne",
                  "nameAr": "Yonne",
                  "nameFr": "Yonne"
            },
            {
                  "name": "Yvelines",
                  "nameAr": "Yvelines",
                  "nameFr": "Yvelines"
            }
      ]
  },
  {
    "code": "HU",
    "name": "Hungary",
    "nameAr": "المجر",
    "nameFr": "Hungary",
    "cities": [
            {
                  "name": "Bács-Kiskun",
                  "nameAr": "Bács-Kiskun",
                  "nameFr": "Bács-Kiskun"
            },
            {
                  "name": "Baranya",
                  "nameAr": "Baranya",
                  "nameFr": "Baranya"
            },
            {
                  "name": "Békés",
                  "nameAr": "Békés",
                  "nameFr": "Békés"
            },
            {
                  "name": "Békéscsaba",
                  "nameAr": "Békéscsaba",
                  "nameFr": "Békéscsaba"
            },
            {
                  "name": "Borsod-Abaúj-Zemplén",
                  "nameAr": "Borsod-Abaúj-Zemplén",
                  "nameFr": "Borsod-Abaúj-Zemplén"
            },
            {
                  "name": "Budapest",
                  "nameAr": "Budapest",
                  "nameFr": "Budapest"
            },
            {
                  "name": "Csongrád County",
                  "nameAr": "Csongrád County",
                  "nameFr": "Csongrád County"
            },
            {
                  "name": "Debrecen",
                  "nameAr": "Debrecen",
                  "nameFr": "Debrecen"
            },
            {
                  "name": "Dunaújváros",
                  "nameAr": "Dunaújváros",
                  "nameFr": "Dunaújváros"
            },
            {
                  "name": "Eger",
                  "nameAr": "Buja",
                  "nameFr": "Eger"
            },
            {
                  "name": "Érd",
                  "nameAr": "Érd",
                  "nameFr": "Érd"
            },
            {
                  "name": "Fejér County",
                  "nameAr": "Fejér County",
                  "nameFr": "Fejér County"
            },
            {
                  "name": "Győr",
                  "nameAr": "Győr",
                  "nameFr": "Győr"
            },
            {
                  "name": "Győr-Moson-Sopron County",
                  "nameAr": "Győr-Moson-Sopron County",
                  "nameFr": "Győr-Moson-Sopron County"
            },
            {
                  "name": "Hajdú-Bihar County",
                  "nameAr": "Hajdú-Bihar County",
                  "nameFr": "Hajdú-Bihar County"
            },
            {
                  "name": "Heves County",
                  "nameAr": "Heves megye",
                  "nameFr": "Heves County"
            },
            {
                  "name": "Hódmezővásárhely",
                  "nameAr": "Hódmezővásárhely",
                  "nameFr": "Hódmezővásárhely"
            },
            {
                  "name": "Jász-Nagykun-Szolnok County",
                  "nameAr": "Jász-Nagykun-Szolnok County",
                  "nameFr": "Jász-Nagykun-Szolnok County"
            },
            {
                  "name": "Kaposvár",
                  "nameAr": "Kaposvár",
                  "nameFr": "Kaposvár"
            },
            {
                  "name": "Kecskemét",
                  "nameAr": "Kecskemét",
                  "nameFr": "Kecskemét"
            },
            {
                  "name": "Komárom-Esztergom",
                  "nameAr": "Komárom-Esztergom",
                  "nameFr": "Komárom-Esztergom"
            },
            {
                  "name": "Miskolc",
                  "nameAr": "Miskolc",
                  "nameFr": "Miskolc"
            },
            {
                  "name": "Nagykanizsa",
                  "nameAr": "Nagykanizsa",
                  "nameFr": "Nagykanizsa"
            },
            {
                  "name": "Nógrád County",
                  "nameAr": "Nógrád County",
                  "nameFr": "Nógrád County"
            },
            {
                  "name": "Nyíregyháza",
                  "nameAr": "Nyíregyháza",
                  "nameFr": "Nyíregyháza"
            },
            {
                  "name": "Pécs",
                  "nameAr": "Pécs",
                  "nameFr": "Pécs"
            },
            {
                  "name": "Pest County",
                  "nameAr": "Kártevő megye",
                  "nameFr": "Pest County"
            },
            {
                  "name": "Salgótarján",
                  "nameAr": "Salgótarján",
                  "nameFr": "Salgótarján"
            },
            {
                  "name": "Somogy County",
                  "nameAr": "Somogy megye",
                  "nameFr": "Somogy County"
            },
            {
                  "name": "Sopron",
                  "nameAr": "Sopron",
                  "nameFr": "Sopron"
            },
            {
                  "name": "Szabolcs-Szatmár-Bereg County",
                  "nameAr": "Szabolcs-Szatmár-Bereg County",
                  "nameFr": "Szabolcs-Szatmár-Bereg County"
            },
            {
                  "name": "Szeged",
                  "nameAr": "Szeged",
                  "nameFr": "Szeged"
            },
            {
                  "name": "Székesfehérvár",
                  "nameAr": "Székesfehérvár",
                  "nameFr": "Székesfehérvár"
            },
            {
                  "name": "Szekszárd",
                  "nameAr": "Szekszárd",
                  "nameFr": "Szekszárd"
            },
            {
                  "name": "Szolnok",
                  "nameAr": "Szolnok",
                  "nameFr": "Szolnok"
            },
            {
                  "name": "Szombathely",
                  "nameAr": "Szombathely",
                  "nameFr": "Szombathely"
            },
            {
                  "name": "Tatabánya",
                  "nameAr": "Tatabánya",
                  "nameFr": "Tatabánya"
            },
            {
                  "name": "Tolna County",
                  "nameAr": "Tolna County",
                  "nameFr": "Tolna County"
            },
            {
                  "name": "Vas County",
                  "nameAr": "Vas County",
                  "nameFr": "Vas County"
            },
            {
                  "name": "Veszprém",
                  "nameAr": "Veszprém",
                  "nameFr": "Veszprém"
            },
            {
                  "name": "Veszprém County",
                  "nameAr": "Veszprém County",
                  "nameFr": "Veszprém County"
            },
            {
                  "name": "Zala County",
                  "nameAr": "Zala megye",
                  "nameFr": "Zala County"
            },
            {
                  "name": "Zalaegerszeg",
                  "nameAr": "Zalaegerszeg",
                  "nameFr": "Zalaegerszeg"
            }
      ]
  },
  {
    "code": "IS",
    "name": "Iceland",
    "nameAr": "آيسلندا",
    "nameFr": "Iceland",
    "cities": [
            {
                  "name": "Capital",
                  "nameAr": "Höfuðborg",
                  "nameFr": "Capital"
            },
            {
                  "name": "Eastern",
                  "nameAr": "Austur",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Northeastern",
                  "nameAr": "Norðaustur",
                  "nameFr": "Northeastern"
            },
            {
                  "name": "Northwestern",
                  "nameAr": "Norðvestur",
                  "nameFr": "Northwestern"
            },
            {
                  "name": "Southern",
                  "nameAr": "Suður",
                  "nameFr": "Southern"
            },
            {
                  "name": "Southern Peninsula",
                  "nameAr": "Suður -skaginn",
                  "nameFr": "Southern Peninsula"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            },
            {
                  "name": "Westfjords",
                  "nameAr": "Westfjords",
                  "nameFr": "Westfjords"
            }
      ]
  },
  {
    "code": "IE",
    "name": "Ireland",
    "nameAr": "أيرلندا",
    "nameFr": "Ireland",
    "cities": [
            {
                  "name": "Carlow",
                  "nameAr": "Carlow",
                  "nameFr": "Carlow"
            },
            {
                  "name": "Cavan",
                  "nameAr": "Cavan",
                  "nameFr": "Cavan"
            },
            {
                  "name": "Clare",
                  "nameAr": "Clare",
                  "nameFr": "Clare"
            },
            {
                  "name": "Connacht",
                  "nameAr": "Connacht",
                  "nameFr": "Connacht"
            },
            {
                  "name": "Cork",
                  "nameAr": "Cork",
                  "nameFr": "Cork"
            },
            {
                  "name": "Donegal",
                  "nameAr": "Donegal",
                  "nameFr": "Donegal"
            },
            {
                  "name": "Dublin",
                  "nameAr": "Dublin",
                  "nameFr": "Dublin"
            },
            {
                  "name": "Galway",
                  "nameAr": "Galway",
                  "nameFr": "Galway"
            },
            {
                  "name": "Kerry",
                  "nameAr": "Kerry",
                  "nameFr": "Kerry"
            },
            {
                  "name": "Kildare",
                  "nameAr": "Kildare",
                  "nameFr": "Kildare"
            },
            {
                  "name": "Kilkenny",
                  "nameAr": "Kilkenny",
                  "nameFr": "Kilkenny"
            },
            {
                  "name": "Laois",
                  "nameAr": "Laois",
                  "nameFr": "Laois"
            },
            {
                  "name": "Leinster",
                  "nameAr": "Leinster",
                  "nameFr": "Leinster"
            },
            {
                  "name": "Leitrim",
                  "nameAr": "Leitrim",
                  "nameFr": "Leitrim"
            },
            {
                  "name": "Limerick",
                  "nameAr": "Limerick",
                  "nameFr": "Limerick"
            },
            {
                  "name": "Longford",
                  "nameAr": "Longford",
                  "nameFr": "Longford"
            },
            {
                  "name": "Louth",
                  "nameAr": "Louth",
                  "nameFr": "Louth"
            },
            {
                  "name": "Mayo",
                  "nameAr": "Mayo",
                  "nameFr": "Mayo"
            },
            {
                  "name": "Meath",
                  "nameAr": "Meath",
                  "nameFr": "Meath"
            },
            {
                  "name": "Monaghan",
                  "nameAr": "Monaghan",
                  "nameFr": "Monaghan"
            },
            {
                  "name": "Munster",
                  "nameAr": "Munster",
                  "nameFr": "Munster"
            },
            {
                  "name": "Offaly",
                  "nameAr": "Offaly",
                  "nameFr": "Offaly"
            },
            {
                  "name": "Roscommon",
                  "nameAr": "Roscommon",
                  "nameFr": "Roscommon"
            },
            {
                  "name": "Sligo",
                  "nameAr": "Sligo",
                  "nameFr": "Sligo"
            },
            {
                  "name": "Tipperary",
                  "nameAr": "Tipperary",
                  "nameFr": "Tipperary"
            },
            {
                  "name": "Ulster",
                  "nameAr": "Ulster",
                  "nameFr": "Ulster"
            },
            {
                  "name": "Waterford",
                  "nameAr": "Waterford",
                  "nameFr": "Waterford"
            },
            {
                  "name": "Westmeath",
                  "nameAr": "Westmeath",
                  "nameFr": "Westmeath"
            },
            {
                  "name": "Wexford",
                  "nameAr": "Wexford",
                  "nameFr": "Wexford"
            },
            {
                  "name": "Wicklow",
                  "nameAr": "Wicklow",
                  "nameFr": "Wicklow"
            }
      ]
  },
  {
    "code": "IT",
    "name": "Italy",
    "nameAr": "إيطاليا",
    "nameFr": "Italy",
    "cities": [
            {
                  "name": "Abruzzo",
                  "nameAr": "Abruzzo",
                  "nameFr": "Abruzzo"
            },
            {
                  "name": "Agrigento",
                  "nameAr": "Agrigento",
                  "nameFr": "Agrigento"
            },
            {
                  "name": "Alessandria",
                  "nameAr": "Alessandria",
                  "nameFr": "Alessandria"
            },
            {
                  "name": "Ancona",
                  "nameAr": "Ancona",
                  "nameFr": "Ancona"
            },
            {
                  "name": "Aosta Valley",
                  "nameAr": "Usando",
                  "nameFr": "Aosta Valley"
            },
            {
                  "name": "Apulia",
                  "nameAr": "Apulia",
                  "nameFr": "Apulia"
            },
            {
                  "name": "Arezzo",
                  "nameAr": "Arezzo",
                  "nameFr": "Arezzo"
            },
            {
                  "name": "Ascoli Piceno",
                  "nameAr": "Ascoli Piceno",
                  "nameFr": "Ascoli Piceno"
            },
            {
                  "name": "Asti",
                  "nameAr": "Asti",
                  "nameFr": "Asti"
            },
            {
                  "name": "Avellino",
                  "nameAr": "Avellino",
                  "nameFr": "Avellino"
            },
            {
                  "name": "Barletta-Andria-Trani",
                  "nameAr": "Barletta-Andria-Trani",
                  "nameFr": "Barletta-Andria-Trani"
            },
            {
                  "name": "Basilicata",
                  "nameAr": "Basilicata",
                  "nameFr": "Basilicata"
            },
            {
                  "name": "Belluno",
                  "nameAr": "Belluno",
                  "nameFr": "Belluno"
            },
            {
                  "name": "Benevento",
                  "nameAr": "Benevento",
                  "nameFr": "Benevento"
            },
            {
                  "name": "Bergamo",
                  "nameAr": "Bergamo",
                  "nameFr": "Bergamo"
            },
            {
                  "name": "Biella",
                  "nameAr": "Biella",
                  "nameFr": "Biella"
            },
            {
                  "name": "Brescia",
                  "nameAr": "Brescia",
                  "nameFr": "Brescia"
            },
            {
                  "name": "Brindisi",
                  "nameAr": "Brindisi",
                  "nameFr": "Brindisi"
            },
            {
                  "name": "Calabria",
                  "nameAr": "Calabria",
                  "nameFr": "Calabria"
            },
            {
                  "name": "Caltanissetta",
                  "nameAr": "Caltanissetta",
                  "nameFr": "Caltanissetta"
            },
            {
                  "name": "Campania",
                  "nameAr": "Campania",
                  "nameFr": "Campania"
            },
            {
                  "name": "Campobasso",
                  "nameAr": "Campobasso",
                  "nameFr": "Campobasso"
            },
            {
                  "name": "Caserta",
                  "nameAr": "Caserta",
                  "nameFr": "Caserta"
            },
            {
                  "name": "Catanzaro",
                  "nameAr": "Catanzaro",
                  "nameFr": "Catanzaro"
            },
            {
                  "name": "Chieti",
                  "nameAr": "Chieti",
                  "nameFr": "Chieti"
            },
            {
                  "name": "Como",
                  "nameAr": "COME",
                  "nameFr": "Como"
            },
            {
                  "name": "Cosenza",
                  "nameAr": "Cosenza",
                  "nameFr": "Cosenza"
            },
            {
                  "name": "Cremona",
                  "nameAr": "Cremona",
                  "nameFr": "Cremona"
            },
            {
                  "name": "Crotone",
                  "nameAr": "Crotone",
                  "nameFr": "Crotone"
            },
            {
                  "name": "Cuneo",
                  "nameAr": "Cuneo",
                  "nameFr": "Cuneo"
            },
            {
                  "name": "Emilia-Romagna",
                  "nameAr": "Emilia-Romagna",
                  "nameFr": "Emilia-Romagna"
            },
            {
                  "name": "Enna",
                  "nameAr": "Enna",
                  "nameFr": "Enna"
            },
            {
                  "name": "Fermo",
                  "nameAr": "Fermo",
                  "nameFr": "Fermo"
            },
            {
                  "name": "Ferrara",
                  "nameAr": "Ferrara",
                  "nameFr": "Ferrara"
            },
            {
                  "name": "Foggia",
                  "nameAr": "Foggia",
                  "nameFr": "Foggia"
            },
            {
                  "name": "Forlì-Cesena",
                  "nameAr": "Forlì-Cesena",
                  "nameFr": "Forlì-Cesena"
            },
            {
                  "name": "Friuli–Venezia Giulia",
                  "nameAr": "Friuli–Venezia Giulia",
                  "nameFr": "Friuli–Venezia Giulia"
            },
            {
                  "name": "Frosinone",
                  "nameAr": "Frosinone",
                  "nameFr": "Frosinone"
            },
            {
                  "name": "Gorizia",
                  "nameAr": "Gorizia",
                  "nameFr": "Gorizia"
            },
            {
                  "name": "Grosseto",
                  "nameAr": "Grosseto",
                  "nameFr": "Grosseto"
            },
            {
                  "name": "Imperia",
                  "nameAr": "Imperia",
                  "nameFr": "Imperia"
            },
            {
                  "name": "Isernia",
                  "nameAr": "Isernia",
                  "nameFr": "Isernia"
            },
            {
                  "name": "L'Aquila",
                  "nameAr": "L'Aquila",
                  "nameFr": "L'Aquila"
            },
            {
                  "name": "La Spezia",
                  "nameAr": "La Spezia",
                  "nameFr": "La Spezia"
            },
            {
                  "name": "Latina",
                  "nameAr": "Latina",
                  "nameFr": "Latina"
            },
            {
                  "name": "Lazio",
                  "nameAr": "Lazio",
                  "nameFr": "Lazio"
            },
            {
                  "name": "Lecce",
                  "nameAr": "Lecce",
                  "nameFr": "Lecce"
            },
            {
                  "name": "Lecco",
                  "nameAr": "Lecco",
                  "nameFr": "Lecco"
            },
            {
                  "name": "Liguria",
                  "nameAr": "Liguria",
                  "nameFr": "Liguria"
            },
            {
                  "name": "Livorno",
                  "nameAr": "Livorno",
                  "nameFr": "Livorno"
            },
            {
                  "name": "Lodi",
                  "nameAr": "Lodi",
                  "nameFr": "Lodi"
            },
            {
                  "name": "Lombardy",
                  "nameAr": "Lombardia",
                  "nameFr": "Lombardy"
            },
            {
                  "name": "Lucca",
                  "nameAr": "Lucca",
                  "nameFr": "Lucca"
            },
            {
                  "name": "Macerata",
                  "nameAr": "Macerata",
                  "nameFr": "Macerata"
            },
            {
                  "name": "Mantua",
                  "nameAr": "Mantova",
                  "nameFr": "Mantua"
            },
            {
                  "name": "Marche",
                  "nameAr": "Marche",
                  "nameFr": "Marche"
            },
            {
                  "name": "Massa and Carrara",
                  "nameAr": "Massa e Carrara",
                  "nameFr": "Massa and Carrara"
            },
            {
                  "name": "Matera",
                  "nameAr": "Matera",
                  "nameFr": "Matera"
            },
            {
                  "name": "Modena",
                  "nameAr": "Modena",
                  "nameFr": "Modena"
            },
            {
                  "name": "Molise",
                  "nameAr": "Molise",
                  "nameFr": "Molise"
            },
            {
                  "name": "Monza and Brianza",
                  "nameAr": "Monza and Brianza",
                  "nameFr": "Monza and Brianza"
            },
            {
                  "name": "Novara",
                  "nameAr": "Novara",
                  "nameFr": "Novara"
            },
            {
                  "name": "Nuoro",
                  "nameAr": "Nuoro",
                  "nameFr": "Nuoro"
            },
            {
                  "name": "Oristano",
                  "nameAr": "Oristano",
                  "nameFr": "Oristano"
            },
            {
                  "name": "Padua",
                  "nameAr": "Padova",
                  "nameFr": "Padua"
            },
            {
                  "name": "Palermo",
                  "nameAr": "Palermo",
                  "nameFr": "Palermo"
            },
            {
                  "name": "Parma",
                  "nameAr": "Parma",
                  "nameFr": "Parma"
            },
            {
                  "name": "Pavia",
                  "nameAr": "Pavia",
                  "nameFr": "Pavia"
            },
            {
                  "name": "Perugia",
                  "nameAr": "Perugia",
                  "nameFr": "Perugia"
            },
            {
                  "name": "Pesaro and Urbino",
                  "nameAr": "Pesaro and Urbino",
                  "nameFr": "Pesaro and Urbino"
            },
            {
                  "name": "Pescara",
                  "nameAr": "Pescara",
                  "nameFr": "Pescara"
            },
            {
                  "name": "Piacenza",
                  "nameAr": "Piacenza",
                  "nameFr": "Piacenza"
            },
            {
                  "name": "Piedmont",
                  "nameAr": "Piemonte",
                  "nameFr": "Piedmont"
            },
            {
                  "name": "Pisa",
                  "nameAr": "Pisa",
                  "nameFr": "Pisa"
            },
            {
                  "name": "Pistoia",
                  "nameAr": "Pistoia",
                  "nameFr": "Pistoia"
            },
            {
                  "name": "Pordenone",
                  "nameAr": "Pordenone",
                  "nameFr": "Pordenone"
            },
            {
                  "name": "Potenza",
                  "nameAr": "Potenza",
                  "nameFr": "Potenza"
            },
            {
                  "name": "Prato",
                  "nameAr": "Prato",
                  "nameFr": "Prato"
            },
            {
                  "name": "Ragusa",
                  "nameAr": "Ragusa",
                  "nameFr": "Ragusa"
            },
            {
                  "name": "Ravenna",
                  "nameAr": "Ravenna",
                  "nameFr": "Ravenna"
            },
            {
                  "name": "Reggio Emilia",
                  "nameAr": "Reggio Emilia",
                  "nameFr": "Reggio Emilia"
            },
            {
                  "name": "Rieti",
                  "nameAr": "Rieti",
                  "nameFr": "Rieti"
            },
            {
                  "name": "Rimini",
                  "nameAr": "Rimini",
                  "nameFr": "Rimini"
            },
            {
                  "name": "Rovigo",
                  "nameAr": "Rovigo",
                  "nameFr": "Rovigo"
            },
            {
                  "name": "Salerno",
                  "nameAr": "Salerno",
                  "nameFr": "Salerno"
            },
            {
                  "name": "Sardinia",
                  "nameAr": "Sardegna",
                  "nameFr": "Sardinia"
            },
            {
                  "name": "Sassari",
                  "nameAr": "Sassari",
                  "nameFr": "Sassari"
            },
            {
                  "name": "Savona",
                  "nameAr": "Savona",
                  "nameFr": "Savona"
            },
            {
                  "name": "Sicily",
                  "nameAr": "Sicilia",
                  "nameFr": "Sicily"
            },
            {
                  "name": "Siena",
                  "nameAr": "Siena",
                  "nameFr": "Siena"
            },
            {
                  "name": "Siracusa",
                  "nameAr": "Siracusa",
                  "nameFr": "Siracusa"
            },
            {
                  "name": "Sondrio",
                  "nameAr": "Sondrio",
                  "nameFr": "Sondrio"
            },
            {
                  "name": "South Sardinia",
                  "nameAr": "Sudinia meridionale",
                  "nameFr": "South Sardinia"
            },
            {
                  "name": "Taranto",
                  "nameAr": "Taranto",
                  "nameFr": "Taranto"
            },
            {
                  "name": "Teramo",
                  "nameAr": "Teramo",
                  "nameFr": "Teramo"
            },
            {
                  "name": "Terni",
                  "nameAr": "Terni",
                  "nameFr": "Terni"
            },
            {
                  "name": "Trapani",
                  "nameAr": "Trapani",
                  "nameFr": "Trapani"
            },
            {
                  "name": "Trentino-South Tyrol",
                  "nameAr": "Trentino-sud Tyrol",
                  "nameFr": "Trentino-South Tyrol"
            },
            {
                  "name": "Treviso",
                  "nameAr": "Treviso",
                  "nameFr": "Treviso"
            },
            {
                  "name": "Trieste",
                  "nameAr": "Trieste",
                  "nameFr": "Trieste"
            },
            {
                  "name": "Tuscany",
                  "nameAr": "Toscana",
                  "nameFr": "Tuscany"
            },
            {
                  "name": "Udine",
                  "nameAr": "Udine",
                  "nameFr": "Udine"
            },
            {
                  "name": "Umbria",
                  "nameAr": "Umbria",
                  "nameFr": "Umbria"
            },
            {
                  "name": "Varese",
                  "nameAr": "Varese",
                  "nameFr": "Varese"
            },
            {
                  "name": "Veneto",
                  "nameAr": "Veneto",
                  "nameFr": "Veneto"
            },
            {
                  "name": "Verbano-Cusio-Ossola",
                  "nameAr": "Verbano-Cusio-Ossola",
                  "nameFr": "Verbano-Cusio-Ossola"
            },
            {
                  "name": "Vercelli",
                  "nameAr": "Vercelli",
                  "nameFr": "Vercelli"
            },
            {
                  "name": "Verona",
                  "nameAr": "Verona",
                  "nameFr": "Verona"
            },
            {
                  "name": "Vibo Valentia",
                  "nameAr": "Vibo Valentia",
                  "nameFr": "Vibo Valentia"
            },
            {
                  "name": "Vicenza",
                  "nameAr": "Vicenza",
                  "nameFr": "Vicenza"
            },
            {
                  "name": "Viterbo",
                  "nameAr": "Viterbo",
                  "nameFr": "Viterbo"
            }
      ]
  },
  {
    "code": "JE",
    "name": "Jersey",
    "nameAr": "جيرسي",
    "nameFr": "Jersey",
    "cities": [
      {
        "name": "Grouville",
        "nameAr": "",
        "nameFr": "Grouville"
      },
      {
        "name": "St Brelade",
        "nameAr": "",
        "nameFr": "St Brelade"
      },
      {
        "name": "St Clement",
        "nameAr": "",
        "nameFr": "St Clement"
      },
      {
        "name": "St Helier",
        "nameAr": "",
        "nameFr": "St Helier"
      },
      {
        "name": "St John",
        "nameAr": "",
        "nameFr": "St John"
      },
      {
        "name": "St Lawrence",
        "nameAr": "",
        "nameFr": "St Lawrence"
      },
      {
        "name": "St Martin",
        "nameAr": "",
        "nameFr": "St Martin"
      },
      {
        "name": "St Mary",
        "nameAr": "",
        "nameFr": "St Mary"
      },
      {
        "name": "St Ouen",
        "nameAr": "",
        "nameFr": "St Ouen"
      },
      {
        "name": "St Peter",
        "nameAr": "",
        "nameFr": "St Peter"
      },
      {
        "name": "St Saviour",
        "nameAr": "",
        "nameFr": "St Saviour"
      },
      {
        "name": "Trinity",
        "nameAr": "",
        "nameFr": "Trinity"
      }
    ]
  },
  {
    "code": "XK",
    "name": "Kosovo",
    "nameAr": "كوسوفو",
    "nameFr": "Kosovo",
    "cities": [
      {
        "name": "Ferizaj",
        "nameAr": "",
        "nameFr": "Ferizaj"
      },
      {
        "name": "Gjakove",
        "nameAr": "",
        "nameFr": "Gjakove"
      },
      {
        "name": "Gjilan",
        "nameAr": "",
        "nameFr": "Gjilan"
      },
      {
        "name": "Mitrovica",
        "nameAr": "",
        "nameFr": "Mitrovica"
      },
      {
        "name": "Peja",
        "nameAr": "",
        "nameFr": "Peja"
      },
      {
        "name": "Pristina",
        "nameAr": "",
        "nameFr": "Pristina"
      },
      {
        "name": "Prizren",
        "nameAr": "",
        "nameFr": "Prizren"
      }
    ]
  },
  {
    "code": "LV",
    "name": "Latvia",
    "nameAr": "لاتفيا",
    "nameFr": "Latvia",
    "cities": [
            {
                  "name": "Ādaži",
                  "nameAr": "Ādaži",
                  "nameFr": "Ādaži"
            },
            {
                  "name": "Aizkraukle",
                  "nameAr": "Aizkraukle",
                  "nameFr": "Aizkraukle"
            },
            {
                  "name": "Alūksne",
                  "nameAr": "Alūksne",
                  "nameFr": "Alūksne"
            },
            {
                  "name": "Augšdaugava",
                  "nameAr": "Augšdaugava",
                  "nameFr": "Augšdaugava"
            },
            {
                  "name": "Balvi",
                  "nameAr": "Balvi",
                  "nameFr": "Balvi"
            },
            {
                  "name": "Bauska",
                  "nameAr": "Bauska",
                  "nameFr": "Bauska"
            },
            {
                  "name": "Cēsis",
                  "nameAr": "Cēsis",
                  "nameFr": "Cēsis"
            },
            {
                  "name": "Daugavpils",
                  "nameAr": "Daugavpils",
                  "nameFr": "Daugavpils"
            },
            {
                  "name": "Dienvidkurzemes",
                  "nameAr": "Dienvidkurzemes",
                  "nameFr": "Dienvidkurzemes"
            },
            {
                  "name": "Dobele",
                  "nameAr": "Dobele",
                  "nameFr": "Dobele"
            },
            {
                  "name": "Gulbene",
                  "nameAr": "Gulbene",
                  "nameFr": "Gulbene"
            },
            {
                  "name": "Jēkabpils",
                  "nameAr": "Jēkabpils",
                  "nameFr": "Jēkabpils"
            },
            {
                  "name": "Jelgava",
                  "nameAr": "Jelgava",
                  "nameFr": "Jelgava"
            },
            {
                  "name": "Jelgava",
                  "nameAr": "Jelgava",
                  "nameFr": "Jelgava"
            },
            {
                  "name": "Jūrmala",
                  "nameAr": "Jūrmala",
                  "nameFr": "Jūrmala"
            },
            {
                  "name": "Ķekava",
                  "nameAr": "Ķekava",
                  "nameFr": "Ķekava"
            },
            {
                  "name": "Krāslava",
                  "nameAr": "Krāslava",
                  "nameFr": "Krāslava"
            },
            {
                  "name": "Kuldīga",
                  "nameAr": "Kuldīga",
                  "nameFr": "Kuldīga"
            },
            {
                  "name": "Liepāja",
                  "nameAr": "Liepāja",
                  "nameFr": "Liepāja"
            },
            {
                  "name": "Limbaži",
                  "nameAr": "Limbaži",
                  "nameFr": "Limbaži"
            },
            {
                  "name": "Līvāni",
                  "nameAr": "Līvāni",
                  "nameFr": "Līvāni"
            },
            {
                  "name": "Ludza",
                  "nameAr": "Ludza",
                  "nameFr": "Ludza"
            },
            {
                  "name": "Madona",
                  "nameAr": "Madona",
                  "nameFr": "Madona"
            },
            {
                  "name": "Mārupe",
                  "nameAr": "Mārupe",
                  "nameFr": "Mārupe"
            },
            {
                  "name": "Ogre",
                  "nameAr": "Ogre",
                  "nameFr": "Ogre"
            },
            {
                  "name": "Olaine",
                  "nameAr": "Olaine",
                  "nameFr": "Olaine"
            },
            {
                  "name": "Preiļi",
                  "nameAr": "Preiļi",
                  "nameFr": "Preiļi"
            },
            {
                  "name": "Rēzekne",
                  "nameAr": "Rēzekne",
                  "nameFr": "Rēzekne"
            },
            {
                  "name": "Rēzekne",
                  "nameAr": "Rēzekne",
                  "nameFr": "Rēzekne"
            },
            {
                  "name": "Riga",
                  "nameAr": "Riga",
                  "nameFr": "Riga"
            },
            {
                  "name": "Ropaži",
                  "nameAr": "Ropaži",
                  "nameFr": "Ropaži"
            },
            {
                  "name": "Salaspils",
                  "nameAr": "Salaspils",
                  "nameFr": "Salaspils"
            },
            {
                  "name": "Saldus",
                  "nameAr": "Mīļš",
                  "nameFr": "Saldus"
            },
            {
                  "name": "Saulkrasti",
                  "nameAr": "Saulkrasti",
                  "nameFr": "Saulkrasti"
            },
            {
                  "name": "Sigulda",
                  "nameAr": "Sigulda",
                  "nameFr": "Sigulda"
            },
            {
                  "name": "Smiltene",
                  "nameAr": "Smiltene",
                  "nameFr": "Smiltene"
            },
            {
                  "name": "Talsi",
                  "nameAr": "Talsi",
                  "nameFr": "Talsi"
            },
            {
                  "name": "Tukums",
                  "nameAr": "Tukums",
                  "nameFr": "Tukums"
            },
            {
                  "name": "Valka",
                  "nameAr": "Valka",
                  "nameFr": "Valka"
            },
            {
                  "name": "Valmiera",
                  "nameAr": "Valmiera",
                  "nameFr": "Valmiera"
            },
            {
                  "name": "Varakļāni",
                  "nameAr": "Varakļāni",
                  "nameFr": "Varakļāni"
            },
            {
                  "name": "Ventspils",
                  "nameAr": "Ventspils",
                  "nameFr": "Ventspils"
            },
            {
                  "name": "Ventspils",
                  "nameAr": "Ventspils",
                  "nameFr": "Ventspils"
            }
      ]
  },
  {
    "code": "LI",
    "name": "Liechtenstein",
    "nameAr": "ليختنشتاين",
    "nameFr": "Liechtenstein",
    "cities": [
            {
                  "name": "Balzers",
                  "nameAr": "Balzern",
                  "nameFr": "Balzers"
            },
            {
                  "name": "Eschen",
                  "nameAr": "Eschen",
                  "nameFr": "Eschen"
            },
            {
                  "name": "Gamprin",
                  "nameAr": "Gamprin",
                  "nameFr": "Gamprin"
            },
            {
                  "name": "Mauren",
                  "nameAr": "Mauren",
                  "nameFr": "Mauren"
            },
            {
                  "name": "Planken",
                  "nameAr": "Planken",
                  "nameFr": "Planken"
            },
            {
                  "name": "Ruggell",
                  "nameAr": "Ruggell",
                  "nameFr": "Ruggell"
            },
            {
                  "name": "Schaan",
                  "nameAr": "Schaan",
                  "nameFr": "Schaan"
            },
            {
                  "name": "Schellenberg",
                  "nameAr": "Schellenberg",
                  "nameFr": "Schellenberg"
            },
            {
                  "name": "Triesen",
                  "nameAr": "Versuche",
                  "nameFr": "Triesen"
            },
            {
                  "name": "Triesenberg",
                  "nameAr": "Triesenberg",
                  "nameFr": "Triesenberg"
            },
            {
                  "name": "Vaduz",
                  "nameAr": "Vaduz",
                  "nameFr": "Vaduz"
            }
      ]
  },
  {
    "code": "LT",
    "name": "Lithuania",
    "nameAr": "ليتوانيا",
    "nameFr": "Lithuania",
    "cities": [
            {
                  "name": "Akmenė",
                  "nameAr": "Akmenė",
                  "nameFr": "Akmenė"
            },
            {
                  "name": "Alytus",
                  "nameAr": "Alytus",
                  "nameFr": "Alytus"
            },
            {
                  "name": "Alytus",
                  "nameAr": "Alytus",
                  "nameFr": "Alytus"
            },
            {
                  "name": "Anykščiai",
                  "nameAr": "Anykščiai",
                  "nameFr": "Anykščiai"
            },
            {
                  "name": "Birštonas",
                  "nameAr": "Birštonas",
                  "nameFr": "Birštonas"
            },
            {
                  "name": "Biržai",
                  "nameAr": "Biržai",
                  "nameFr": "Biržai"
            },
            {
                  "name": "Druskininkai",
                  "nameAr": "Druskininkai",
                  "nameFr": "Druskininkai"
            },
            {
                  "name": "Elektrėnai",
                  "nameAr": "Elektrėnai",
                  "nameFr": "Elektrėnai"
            },
            {
                  "name": "Ignalina",
                  "nameAr": "Ignalina",
                  "nameFr": "Ignalina"
            },
            {
                  "name": "Jonava",
                  "nameAr": "Jonava",
                  "nameFr": "Jonava"
            },
            {
                  "name": "Joniškis",
                  "nameAr": "Joniškis",
                  "nameFr": "Joniškis"
            },
            {
                  "name": "Jurbarkas",
                  "nameAr": "Jurbarkas",
                  "nameFr": "Jurbarkas"
            },
            {
                  "name": "Kaišiadorys",
                  "nameAr": "Kaišiadorys",
                  "nameFr": "Kaišiadorys"
            },
            {
                  "name": "Kalvarija",
                  "nameAr": "Kalvarija",
                  "nameFr": "Kalvarija"
            },
            {
                  "name": "Kaunas",
                  "nameAr": "Kaunas",
                  "nameFr": "Kaunas"
            },
            {
                  "name": "Kaunas",
                  "nameAr": "Kaunas",
                  "nameFr": "Kaunas"
            },
            {
                  "name": "Kazlų Rūda",
                  "nameAr": "Kazlų Rūda",
                  "nameFr": "Kazlų Rūda"
            },
            {
                  "name": "Kėdainiai",
                  "nameAr": "Kėdainiai",
                  "nameFr": "Kėdainiai"
            },
            {
                  "name": "Kelmė",
                  "nameAr": "Kelmė",
                  "nameFr": "Kelmė"
            },
            {
                  "name": "Klaipėda",
                  "nameAr": "Klaipėda",
                  "nameFr": "Klaipėda"
            },
            {
                  "name": "Klaipėda",
                  "nameAr": "Klaipėda",
                  "nameFr": "Klaipėda"
            },
            {
                  "name": "Kretinga",
                  "nameAr": "Kretinga",
                  "nameFr": "Kretinga"
            },
            {
                  "name": "Kupiškis",
                  "nameAr": "Kupiškis",
                  "nameFr": "Kupiškis"
            },
            {
                  "name": "Lazdijai",
                  "nameAr": "Lazdijai",
                  "nameFr": "Lazdijai"
            },
            {
                  "name": "Marijampolė",
                  "nameAr": "Marijampolė",
                  "nameFr": "Marijampolė"
            },
            {
                  "name": "Marijampolė",
                  "nameAr": "Marijampolė",
                  "nameFr": "Marijampolė"
            },
            {
                  "name": "Mažeikiai",
                  "nameAr": "Mažeikiai",
                  "nameFr": "Mažeikiai"
            },
            {
                  "name": "Molėtai",
                  "nameAr": "Molėtai",
                  "nameFr": "Molėtai"
            },
            {
                  "name": "Neringa",
                  "nameAr": "Neringa",
                  "nameFr": "Neringa"
            },
            {
                  "name": "Pagėgiai",
                  "nameAr": "Pagėgiai",
                  "nameFr": "Pagėgiai"
            },
            {
                  "name": "Pakruojis",
                  "nameAr": "Pakruojis",
                  "nameFr": "Pakruojis"
            },
            {
                  "name": "Palanga",
                  "nameAr": "Palanga",
                  "nameFr": "Palanga"
            },
            {
                  "name": "Panevėžys",
                  "nameAr": "Panevėžys",
                  "nameFr": "Panevėžys"
            },
            {
                  "name": "Panevėžys",
                  "nameAr": "Panevėžys",
                  "nameFr": "Panevėžys"
            },
            {
                  "name": "Pasvalys",
                  "nameAr": "Pasvalys",
                  "nameFr": "Pasvalys"
            },
            {
                  "name": "Plungė",
                  "nameAr": "Plungė",
                  "nameFr": "Plungė"
            },
            {
                  "name": "Prienai",
                  "nameAr": "Prienai",
                  "nameFr": "Prienai"
            },
            {
                  "name": "Radviliškis",
                  "nameAr": "Radviliškis",
                  "nameFr": "Radviliškis"
            },
            {
                  "name": "Raseiniai",
                  "nameAr": "Raseiniai",
                  "nameFr": "Raseiniai"
            },
            {
                  "name": "Rietavas",
                  "nameAr": "Rietavas",
                  "nameFr": "Rietavas"
            },
            {
                  "name": "Rokiškis",
                  "nameAr": "Rokiškis",
                  "nameFr": "Rokiškis"
            },
            {
                  "name": "Šakiai",
                  "nameAr": "Šakiai",
                  "nameFr": "Šakiai"
            },
            {
                  "name": "Šalčininkai",
                  "nameAr": "Šalčininkai",
                  "nameFr": "Šalčininkai"
            },
            {
                  "name": "Šiauliai",
                  "nameAr": "Šiauliai",
                  "nameFr": "Šiauliai"
            },
            {
                  "name": "Šiauliai",
                  "nameAr": "Šiauliai",
                  "nameFr": "Šiauliai"
            },
            {
                  "name": "Šilalė ",
                  "nameAr": "Šilalė",
                  "nameFr": "Šilalė "
            },
            {
                  "name": "Šilutė",
                  "nameAr": "Šilutė",
                  "nameFr": "Šilutė"
            },
            {
                  "name": "Širvintos",
                  "nameAr": "Širvintos",
                  "nameFr": "Širvintos"
            },
            {
                  "name": "Skuodas",
                  "nameAr": "Skuodas",
                  "nameFr": "Skuodas"
            },
            {
                  "name": "Švenčionys",
                  "nameAr": "Švenčionys",
                  "nameFr": "Švenčionys"
            },
            {
                  "name": "Tauragė",
                  "nameAr": "Tauragė",
                  "nameFr": "Tauragė"
            },
            {
                  "name": "Tauragė",
                  "nameAr": "Tauragė",
                  "nameFr": "Tauragė"
            },
            {
                  "name": "Telšiai",
                  "nameAr": "Telšiai",
                  "nameFr": "Telšiai"
            },
            {
                  "name": "Telšiai",
                  "nameAr": "Telšiai",
                  "nameFr": "Telšiai"
            },
            {
                  "name": "Trakai",
                  "nameAr": "Trakai",
                  "nameFr": "Trakai"
            },
            {
                  "name": "Ukmergė",
                  "nameAr": "Ukmergė",
                  "nameFr": "Ukmergė"
            },
            {
                  "name": "Utena",
                  "nameAr": "Utena",
                  "nameFr": "Utena"
            },
            {
                  "name": "Utena",
                  "nameAr": "Utena",
                  "nameFr": "Utena"
            },
            {
                  "name": "Varėna",
                  "nameAr": "Varėna",
                  "nameFr": "Varėna"
            },
            {
                  "name": "Vilkaviškis",
                  "nameAr": "Vilkaviškis",
                  "nameFr": "Vilkaviškis"
            },
            {
                  "name": "Vilnius",
                  "nameAr": "Vilnius",
                  "nameFr": "Vilnius"
            },
            {
                  "name": "Vilnius",
                  "nameAr": "Vilnius",
                  "nameFr": "Vilnius"
            },
            {
                  "name": "Visaginas",
                  "nameAr": "Visaginas",
                  "nameFr": "Visaginas"
            },
            {
                  "name": "Zarasai",
                  "nameAr": "Zarasai",
                  "nameFr": "Zarasai"
            }
      ]
  },
  {
    "code": "LU",
    "name": "Luxembourg",
    "nameAr": "لوكسمبورغ",
    "nameFr": "Luxembourg",
    "cities": [
            {
                  "name": "Capellen",
                  "nameAr": "Rond",
                  "nameFr": "Capellen"
            },
            {
                  "name": "Clervaux",
                  "nameAr": "Clervaux",
                  "nameFr": "Clervaux"
            },
            {
                  "name": "Diekirch",
                  "nameAr": "Diekkch",
                  "nameFr": "Diekirch"
            },
            {
                  "name": "Echternach",
                  "nameAr": "Empire",
                  "nameFr": "Echternach"
            },
            {
                  "name": "Esch-sur-Alzette",
                  "nameAr": "Plancher-sur-alzette",
                  "nameFr": "Esch-sur-Alzette"
            },
            {
                  "name": "Grevenmacher",
                  "nameAr": "Great",
                  "nameFr": "Grevenmacher"
            },
            {
                  "name": "Luxembourg ",
                  "nameAr": "Luxembourg",
                  "nameFr": "Luxembourg "
            },
            {
                  "name": "Mersch",
                  "nameAr": "Marchandi",
                  "nameFr": "Mersch"
            },
            {
                  "name": "Redange",
                  "nameAr": "Réorganiser",
                  "nameFr": "Redange"
            },
            {
                  "name": "Remich",
                  "nameAr": "Remtors",
                  "nameFr": "Remich"
            },
            {
                  "name": "Vianden",
                  "nameAr": "Vues",
                  "nameFr": "Vianden"
            },
            {
                  "name": "Wiltz",
                  "nameAr": "Wiltsz",
                  "nameFr": "Wiltz"
            }
      ]
  },
  {
    "code": "MT",
    "name": "Malta",
    "nameAr": "مالطا",
    "nameFr": "Malta",
    "cities": [
            {
                  "name": "Attard",
                  "nameAr": "Attard",
                  "nameFr": "Attard"
            },
            {
                  "name": "Balzan",
                  "nameAr": "Balzan",
                  "nameFr": "Balzan"
            },
            {
                  "name": "Birgu",
                  "nameAr": "Birgu",
                  "nameFr": "Birgu"
            },
            {
                  "name": "Birkirkara",
                  "nameAr": "Birkirkara",
                  "nameFr": "Birkirkara"
            },
            {
                  "name": "Birżebbuġa",
                  "nameAr": "Birżebbuġa",
                  "nameFr": "Birżebbuġa"
            },
            {
                  "name": "Cospicua",
                  "nameAr": "Evidenti",
                  "nameFr": "Cospicua"
            },
            {
                  "name": "Dingli",
                  "nameAr": "Dingli",
                  "nameFr": "Dingli"
            },
            {
                  "name": "Fgura",
                  "nameAr": "Fgura",
                  "nameFr": "Fgura"
            },
            {
                  "name": "Floriana",
                  "nameAr": "Floriana",
                  "nameFr": "Floriana"
            },
            {
                  "name": "Fontana",
                  "nameAr": "Fontana",
                  "nameFr": "Fontana"
            },
            {
                  "name": "Għajnsielem",
                  "nameAr": "Għajnsielem",
                  "nameFr": "Għajnsielem"
            },
            {
                  "name": "Għarb",
                  "nameAr": "Għarb",
                  "nameFr": "Għarb"
            },
            {
                  "name": "Għargħur",
                  "nameAr": "Għargħur",
                  "nameFr": "Għargħur"
            },
            {
                  "name": "Għasri",
                  "nameAr": "Għasri",
                  "nameFr": "Għasri"
            },
            {
                  "name": "Għaxaq",
                  "nameAr": "Għaxaq",
                  "nameFr": "Għaxaq"
            },
            {
                  "name": "Gudja",
                  "nameAr": "Gudja",
                  "nameFr": "Gudja"
            },
            {
                  "name": "Gżira",
                  "nameAr": "Gżira",
                  "nameFr": "Gżira"
            },
            {
                  "name": "Ħamrun",
                  "nameAr": "Ħamrun",
                  "nameFr": "Ħamrun"
            },
            {
                  "name": "Iklin",
                  "nameAr": "Iklin",
                  "nameFr": "Iklin"
            },
            {
                  "name": "Kalkara",
                  "nameAr": "Kalkara",
                  "nameFr": "Kalkara"
            },
            {
                  "name": "Kerċem",
                  "nameAr": "Kerċem",
                  "nameFr": "Kerċem"
            },
            {
                  "name": "Kirkop",
                  "nameAr": "Chirop",
                  "nameFr": "Kirkop"
            },
            {
                  "name": "Lija",
                  "nameAr": "Rabid",
                  "nameFr": "Lija"
            },
            {
                  "name": "Luqa",
                  "nameAr": "Luqa",
                  "nameFr": "Luqa"
            },
            {
                  "name": "Marsa",
                  "nameAr": "Marsa",
                  "nameFr": "Marsa"
            },
            {
                  "name": "Marsaskala",
                  "nameAr": "Marsaskala",
                  "nameFr": "Marsaskala"
            },
            {
                  "name": "Marsaxlokk",
                  "nameAr": "Marsaxlokk",
                  "nameFr": "Marsaxlokk"
            },
            {
                  "name": "Mdina",
                  "nameAr": "Mdina",
                  "nameFr": "Mdina"
            },
            {
                  "name": "Mellieħa",
                  "nameAr": "Mellieħa",
                  "nameFr": "Mellieħa"
            },
            {
                  "name": "Mġarr",
                  "nameAr": "Mġarr",
                  "nameFr": "Mġarr"
            },
            {
                  "name": "Mosta",
                  "nameAr": "Pont",
                  "nameFr": "Mosta"
            },
            {
                  "name": "Mqabba",
                  "nameAr": "Mqabba",
                  "nameFr": "Mqabba"
            },
            {
                  "name": "Msida",
                  "nameAr": "Msida",
                  "nameFr": "Msida"
            },
            {
                  "name": "Mtarfa",
                  "nameAr": "Mtarfa",
                  "nameFr": "Mtarfa"
            },
            {
                  "name": "Munxar",
                  "nameAr": "Munxar",
                  "nameFr": "Munxar"
            },
            {
                  "name": "Nadur",
                  "nameAr": "Nadur",
                  "nameFr": "Nadur"
            },
            {
                  "name": "Naxxar",
                  "nameAr": "Naxxar",
                  "nameFr": "Naxxar"
            },
            {
                  "name": "Paola",
                  "nameAr": "Paola",
                  "nameFr": "Paola"
            },
            {
                  "name": "Pembroke",
                  "nameAr": "Pembroke",
                  "nameFr": "Pembroke"
            },
            {
                  "name": "Pietà",
                  "nameAr": "Kompassjoni",
                  "nameFr": "Pietà"
            },
            {
                  "name": "Qala",
                  "nameAr": "Ibda",
                  "nameFr": "Qala"
            },
            {
                  "name": "Qormi",
                  "nameAr": "Qormi",
                  "nameFr": "Qormi"
            },
            {
                  "name": "Qrendi",
                  "nameAr": "Qrendi",
                  "nameFr": "Qrendi"
            },
            {
                  "name": "Rabat",
                  "nameAr": "Rabat",
                  "nameFr": "Rabat"
            },
            {
                  "name": "San Ġwann",
                  "nameAr": "San Ġwann",
                  "nameFr": "San Ġwann"
            },
            {
                  "name": "San Lawrenz",
                  "nameAr": "San Lawrenz",
                  "nameFr": "San Lawrenz"
            },
            {
                  "name": "Sannat",
                  "nameAr": "Sannat",
                  "nameFr": "Sannat"
            },
            {
                  "name": "Santa Luċija",
                  "nameAr": "Santa Luċija",
                  "nameFr": "Santa Luċija"
            },
            {
                  "name": "Santa Venera",
                  "nameAr": "Santa Venera",
                  "nameFr": "Santa Venera"
            },
            {
                  "name": "Senglea",
                  "nameAr": "Senglea",
                  "nameFr": "Senglea"
            },
            {
                  "name": "Siġġiewi",
                  "nameAr": "Siġġiewi",
                  "nameFr": "Siġġiewi"
            },
            {
                  "name": "Sliema",
                  "nameAr": "Sliema",
                  "nameFr": "Sliema"
            },
            {
                  "name": "St. Julian's",
                  "nameAr": "San Ġiljan",
                  "nameFr": "St. Julian's"
            },
            {
                  "name": "St. Paul's Bay",
                  "nameAr": "Bajja ta ’San Pawl",
                  "nameFr": "St. Paul's Bay"
            },
            {
                  "name": "Swieqi",
                  "nameAr": "Swieqi",
                  "nameFr": "Swieqi"
            },
            {
                  "name": "Ta' Xbiex",
                  "nameAr": "Ta' Xbiex",
                  "nameFr": "Ta' Xbiex"
            },
            {
                  "name": "Tarxien",
                  "nameAr": "Tarxien",
                  "nameFr": "Tarxien"
            },
            {
                  "name": "Valletta",
                  "nameAr": "Valletta",
                  "nameFr": "Valletta"
            },
            {
                  "name": "Victoria",
                  "nameAr": "Victoria",
                  "nameFr": "Victoria"
            },
            {
                  "name": "Xagħra",
                  "nameAr": "Xagħra",
                  "nameFr": "Xagħra"
            },
            {
                  "name": "Xewkija",
                  "nameAr": "Xewkija",
                  "nameFr": "Xewkija"
            },
            {
                  "name": "Xgħajra",
                  "nameAr": "Xgħajra",
                  "nameFr": "Xgħajra"
            },
            {
                  "name": "Żabbar",
                  "nameAr": "Żabbar",
                  "nameFr": "Żabbar"
            },
            {
                  "name": "Żebbuġ Gozo",
                  "nameAr": "Żebbuġ Gozo",
                  "nameFr": "Żebbuġ Gozo"
            },
            {
                  "name": "Żebbuġ Malta",
                  "nameAr": "Żebbuġ Malta",
                  "nameFr": "Żebbuġ Malta"
            },
            {
                  "name": "Żejtun",
                  "nameAr": "Żejtun",
                  "nameFr": "Żejtun"
            },
            {
                  "name": "Żurrieq",
                  "nameAr": "Żurrieq",
                  "nameFr": "Żurrieq"
            }
      ]
  },
  {
    "code": "IM",
    "name": "Man (Isle of)",
    "nameAr": "جزيرة مان",
    "nameFr": "Man (Isle of)",
    "cities": [
      {
        "name": "Ayre",
        "nameAr": "",
        "nameFr": "Ayre"
      },
      {
        "name": "Garff",
        "nameAr": "",
        "nameFr": "Garff"
      },
      {
        "name": "Glenfaba",
        "nameAr": "",
        "nameFr": "Glenfaba"
      },
      {
        "name": "Michael",
        "nameAr": "",
        "nameFr": "Michael"
      },
      {
        "name": "Middle",
        "nameAr": "",
        "nameFr": "Middle"
      },
      {
        "name": "Rushen",
        "nameAr": "",
        "nameFr": "Rushen"
      }
    ]
  },
  {
    "code": "MD",
    "name": "Moldova",
    "nameAr": "مولدوفا",
    "nameFr": "Moldova",
    "cities": [
            {
                  "name": "Anenii Noi",
                  "nameAr": "Anenii Noi",
                  "nameFr": "Anenii Noi"
            },
            {
                  "name": "Bălți",
                  "nameAr": "Bălți",
                  "nameFr": "Bălți"
            },
            {
                  "name": "Basarabeasca",
                  "nameAr": "Basarabeasca",
                  "nameFr": "Basarabeasca"
            },
            {
                  "name": "Bender",
                  "nameAr": "Bender",
                  "nameFr": "Bender"
            },
            {
                  "name": "Briceni",
                  "nameAr": "Briceni",
                  "nameFr": "Briceni"
            },
            {
                  "name": "Cahul",
                  "nameAr": "Cahul",
                  "nameFr": "Cahul"
            },
            {
                  "name": "Călărași",
                  "nameAr": "Călărași",
                  "nameFr": "Călărași"
            },
            {
                  "name": "Cantemir",
                  "nameAr": "Cantemir",
                  "nameFr": "Cantemir"
            },
            {
                  "name": "Căușeni",
                  "nameAr": "Căușeni",
                  "nameFr": "Căușeni"
            },
            {
                  "name": "Chișinău",
                  "nameAr": "Chișinău",
                  "nameFr": "Chișinău"
            },
            {
                  "name": "Cimișlia",
                  "nameAr": "Cimișlia",
                  "nameFr": "Cimișlia"
            },
            {
                  "name": "Criuleni",
                  "nameAr": "Criuleni",
                  "nameFr": "Criuleni"
            },
            {
                  "name": "Dondușeni",
                  "nameAr": "Dondușeni",
                  "nameFr": "Dondușeni"
            },
            {
                  "name": "Drochia",
                  "nameAr": "Drochia",
                  "nameFr": "Drochia"
            },
            {
                  "name": "Dubăsari",
                  "nameAr": "Dubăsari",
                  "nameFr": "Dubăsari"
            },
            {
                  "name": "Edineț",
                  "nameAr": "Edineț",
                  "nameFr": "Edineț"
            },
            {
                  "name": "Fălești",
                  "nameAr": "Fălești",
                  "nameFr": "Fălești"
            },
            {
                  "name": "Florești",
                  "nameAr": "Florești",
                  "nameFr": "Florești"
            },
            {
                  "name": "Gagauzia",
                  "nameAr": "Gagauzia",
                  "nameFr": "Gagauzia"
            },
            {
                  "name": "Glodeni",
                  "nameAr": "Glodeni",
                  "nameFr": "Glodeni"
            },
            {
                  "name": "Hîncești",
                  "nameAr": "Hîncești",
                  "nameFr": "Hîncești"
            },
            {
                  "name": "Ialoveni",
                  "nameAr": "Ialoveni",
                  "nameFr": "Ialoveni"
            },
            {
                  "name": "Nisporeni",
                  "nameAr": "Nisporeni",
                  "nameFr": "Nisporeni"
            },
            {
                  "name": "Ocnița",
                  "nameAr": "Ocnița",
                  "nameFr": "Ocnița"
            },
            {
                  "name": "Orhei",
                  "nameAr": "Orhei",
                  "nameFr": "Orhei"
            },
            {
                  "name": "Rezina",
                  "nameAr": "Cauciuc",
                  "nameFr": "Rezina"
            },
            {
                  "name": "Rîșcani",
                  "nameAr": "Rîșcani",
                  "nameFr": "Rîșcani"
            },
            {
                  "name": "Sîngerei",
                  "nameAr": "Sîngerei",
                  "nameFr": "Sîngerei"
            },
            {
                  "name": "Șoldănești",
                  "nameAr": "Șoldănești",
                  "nameFr": "Șoldănești"
            },
            {
                  "name": "Soroca",
                  "nameAr": "Soroca",
                  "nameFr": "Soroca"
            },
            {
                  "name": "Ștefan Vodă",
                  "nameAr": "Ștefan Vodă",
                  "nameFr": "Ștefan Vodă"
            },
            {
                  "name": "Strășeni",
                  "nameAr": "Strășeni",
                  "nameFr": "Strășeni"
            },
            {
                  "name": "Taraclia",
                  "nameAr": "Taraclia",
                  "nameFr": "Taraclia"
            },
            {
                  "name": "Telenești",
                  "nameAr": "Telenești",
                  "nameFr": "Telenești"
            },
            {
                  "name": "Transnistria",
                  "nameAr": "Transnistria",
                  "nameFr": "Transnistria"
            },
            {
                  "name": "Ungheni",
                  "nameAr": "Ungheni",
                  "nameFr": "Ungheni"
            }
      ]
  },
  {
    "code": "MC",
    "name": "Monaco",
    "nameAr": "موناكو",
    "nameFr": "Monaco",
    "cities": [
            {
                  "name": "La Colle",
                  "nameAr": "La Colle",
                  "nameFr": "La Colle"
            },
            {
                  "name": "La Condamine",
                  "nameAr": "La Condamine",
                  "nameFr": "La Condamine"
            },
            {
                  "name": "Moneghetti",
                  "nameAr": "Mongotti",
                  "nameFr": "Moneghetti"
            }
      ]
  },
  {
    "code": "ME",
    "name": "Montenegro",
    "nameAr": "الجبل الأسود",
    "nameFr": "Montenegro",
    "cities": [
      {
        "name": "Andrijevica",
        "nameAr": "",
        "nameFr": "Andrijevica"
      },
      {
        "name": "Bar",
        "nameAr": "",
        "nameFr": "Bar"
      },
      {
        "name": "Berane",
        "nameAr": "",
        "nameFr": "Berane"
      },
      {
        "name": "Bijelo Polje",
        "nameAr": "",
        "nameFr": "Bijelo Polje"
      },
      {
        "name": "Budva",
        "nameAr": "",
        "nameFr": "Budva"
      },
      {
        "name": "Danilovgrad",
        "nameAr": "",
        "nameFr": "Danilovgrad"
      },
      {
        "name": "Gusinje",
        "nameAr": "",
        "nameFr": "Gusinje"
      },
      {
        "name": "Kolašin",
        "nameAr": "",
        "nameFr": "Kolašin"
      },
      {
        "name": "Kotor",
        "nameAr": "",
        "nameFr": "Kotor"
      },
      {
        "name": "Mojkovac",
        "nameAr": "",
        "nameFr": "Mojkovac"
      },
      {
        "name": "Nikšić",
        "nameAr": "",
        "nameFr": "Nikšić"
      },
      {
        "name": "Old Royal Capital Cetinje",
        "nameAr": "",
        "nameFr": "Old Royal Capital Cetinje"
      },
      {
        "name": "Petnjica",
        "nameAr": "",
        "nameFr": "Petnjica"
      },
      {
        "name": "Plav",
        "nameAr": "",
        "nameFr": "Plav"
      },
      {
        "name": "Pljevlja",
        "nameAr": "",
        "nameFr": "Pljevlja"
      },
      {
        "name": "Plužine",
        "nameAr": "",
        "nameFr": "Plužine"
      },
      {
        "name": "Podgorica",
        "nameAr": "",
        "nameFr": "Podgorica"
      },
      {
        "name": "Rožaje",
        "nameAr": "",
        "nameFr": "Rožaje"
      },
      {
        "name": "Šavnik",
        "nameAr": "",
        "nameFr": "Šavnik"
      },
      {
        "name": "Tivat",
        "nameAr": "",
        "nameFr": "Tivat"
      },
      {
        "name": "Ulcinj",
        "nameAr": "",
        "nameFr": "Ulcinj"
      },
      {
        "name": "Žabljak",
        "nameAr": "",
        "nameFr": "Žabljak"
      }
    ]
  },
  {
    "code": "NL",
    "name": "Netherlands",
    "nameAr": "هولندا",
    "nameFr": "Netherlands",
    "cities": [
            {
                  "name": "Drenthe",
                  "nameAr": "Drenthe",
                  "nameFr": "Drenthe"
            },
            {
                  "name": "Flevoland",
                  "nameAr": "Flevoland",
                  "nameFr": "Flevoland"
            },
            {
                  "name": "Friesland",
                  "nameAr": "Frieland",
                  "nameFr": "Friesland"
            },
            {
                  "name": "Gelderland",
                  "nameAr": "Gelderland",
                  "nameFr": "Gelderland"
            },
            {
                  "name": "Groningen",
                  "nameAr": "Groningen",
                  "nameFr": "Groningen"
            },
            {
                  "name": "Limburg",
                  "nameAr": "Limburg",
                  "nameFr": "Limburg"
            },
            {
                  "name": "North Brabant",
                  "nameAr": "Noord-Brabant",
                  "nameFr": "North Brabant"
            },
            {
                  "name": "North Holland",
                  "nameAr": "Noord-Holland",
                  "nameFr": "North Holland"
            },
            {
                  "name": "Overijssel",
                  "nameAr": "Overijssel",
                  "nameFr": "Overijssel"
            },
            {
                  "name": "South Holland",
                  "nameAr": "Zuid -Holland",
                  "nameFr": "South Holland"
            },
            {
                  "name": "Utrecht",
                  "nameAr": "Utrecht",
                  "nameFr": "Utrecht"
            },
            {
                  "name": "Zeeland",
                  "nameAr": "Zeeland",
                  "nameFr": "Zeeland"
            }
      ]
  },
  {
    "code": "MK",
    "name": "North Macedonia",
    "nameAr": "مقدونيا الشمالية",
    "nameFr": "North Macedonia",
    "cities": [
            {
                  "name": "Aerodrom",
                  "nameAr": "Аеродром",
                  "nameFr": "Aerodrom"
            },
            {
                  "name": "Aračinovo",
                  "nameAr": "Арина",
                  "nameFr": "Aračinovo"
            },
            {
                  "name": "Berovo",
                  "nameAr": "Берово",
                  "nameFr": "Berovo"
            },
            {
                  "name": "Bitola",
                  "nameAr": "Мерач",
                  "nameFr": "Bitola"
            },
            {
                  "name": "Bogdanci",
                  "nameAr": "Богданци",
                  "nameFr": "Bogdanci"
            },
            {
                  "name": "Bogovinje",
                  "nameAr": "Годвт",
                  "nameFr": "Bogovinje"
            },
            {
                  "name": "Bosilovo",
                  "nameAr": "Босилово",
                  "nameFr": "Bosilovo"
            },
            {
                  "name": "Brvenica",
                  "nameAr": "Брвеница",
                  "nameFr": "Brvenica"
            },
            {
                  "name": "Butel",
                  "nameAr": "Бутел",
                  "nameFr": "Butel"
            },
            {
                  "name": "Čair",
                  "nameAr": "Стол",
                  "nameFr": "Čair"
            },
            {
                  "name": "Čaška",
                  "nameAr": "Хокеј",
                  "nameFr": "Čaška"
            },
            {
                  "name": "Centar",
                  "nameAr": "Центар",
                  "nameFr": "Centar"
            },
            {
                  "name": "Centar Župa",
                  "nameAr": "Парохиски центар",
                  "nameFr": "Centar Župa"
            },
            {
                  "name": "Češinovo-Obleševo",
                  "nameAr": "Češinovo-Obleševo",
                  "nameFr": "Češinovo-Obleševo"
            },
            {
                  "name": "Čučer-Sandevo",
                  "nameAr": "Čуер-Сандево",
                  "nameFr": "Čučer-Sandevo"
            },
            {
                  "name": "Debarca",
                  "nameAr": "Земја",
                  "nameFr": "Debarca"
            },
            {
                  "name": "Delčevo",
                  "nameAr": "Дека",
                  "nameFr": "Delčevo"
            },
            {
                  "name": "Demir Hisar",
                  "nameAr": "Ironелезна тврдина",
                  "nameFr": "Demir Hisar"
            },
            {
                  "name": "Demir Kapija",
                  "nameAr": "Демир порта",
                  "nameFr": "Demir Kapija"
            },
            {
                  "name": "Dojran",
                  "nameAr": "Изменете",
                  "nameFr": "Dojran"
            },
            {
                  "name": "Dolneni",
                  "nameAr": "Долнени",
                  "nameFr": "Dolneni"
            },
            {
                  "name": "Drugovo",
                  "nameAr": "Леково",
                  "nameFr": "Drugovo"
            },
            {
                  "name": "Gazi Baba",
                  "nameAr": "Гази Баба",
                  "nameFr": "Gazi Baba"
            },
            {
                  "name": "Gevgelija",
                  "nameAr": "Гевгелиум",
                  "nameFr": "Gevgelija"
            },
            {
                  "name": "Gjorče Petrov",
                  "nameAr": "Gjorče Petrov",
                  "nameFr": "Gjorče Petrov"
            },
            {
                  "name": "Gostivar",
                  "nameAr": "Гостивар",
                  "nameFr": "Gostivar"
            },
            {
                  "name": "Gradsko",
                  "nameAr": "Град",
                  "nameFr": "Gradsko"
            },
            {
                  "name": "Greater Skopje",
                  "nameAr": "Поголем Скопје",
                  "nameFr": "Greater Skopje"
            },
            {
                  "name": "Ilinden",
                  "nameAr": "Од",
                  "nameFr": "Ilinden"
            },
            {
                  "name": "Jegunovce",
                  "nameAr": "Јегуновце",
                  "nameFr": "Jegunovce"
            },
            {
                  "name": "Karbinci",
                  "nameAr": "Товар",
                  "nameFr": "Karbinci"
            },
            {
                  "name": "Karpoš",
                  "nameAr": "Карпох",
                  "nameFr": "Karpoš"
            },
            {
                  "name": "Kavadarci",
                  "nameAr": "Кавадарци",
                  "nameFr": "Kavadarci"
            },
            {
                  "name": "Kičevo",
                  "nameAr": "Кич",
                  "nameFr": "Kičevo"
            },
            {
                  "name": "Kisela Voda",
                  "nameAr": "Кисела Вода",
                  "nameFr": "Kisela Voda"
            },
            {
                  "name": "Kočani",
                  "nameAr": "Колиби",
                  "nameFr": "Kočani"
            },
            {
                  "name": "Konče",
                  "nameAr": "Konče",
                  "nameFr": "Konče"
            },
            {
                  "name": "Kratovo",
                  "nameAr": "Кратово",
                  "nameFr": "Kratovo"
            },
            {
                  "name": "Kriva Palanka",
                  "nameAr": "Паланката е виновна",
                  "nameFr": "Kriva Palanka"
            },
            {
                  "name": "Krivogaštani",
                  "nameAr": "Ерес",
                  "nameFr": "Krivogaštani"
            },
            {
                  "name": "Kruševo",
                  "nameAr": "Kruševo",
                  "nameFr": "Kruševo"
            },
            {
                  "name": "Kumanovo",
                  "nameAr": "Куманов",
                  "nameFr": "Kumanovo"
            },
            {
                  "name": "Lipkovo",
                  "nameAr": "Липково",
                  "nameFr": "Lipkovo"
            },
            {
                  "name": "Lozovo",
                  "nameAr": "Лозово",
                  "nameFr": "Lozovo"
            },
            {
                  "name": "Makedonska Kamenica",
                  "nameAr": "Македонски остриги",
                  "nameFr": "Makedonska Kamenica"
            },
            {
                  "name": "Makedonski Brod",
                  "nameAr": "Makedonski Brod",
                  "nameFr": "Makedonski Brod"
            },
            {
                  "name": "Mavrovo and Rostuša",
                  "nameAr": "Маврово и Ростуша",
                  "nameFr": "Mavrovo and Rostuša"
            },
            {
                  "name": "Mogila",
                  "nameAr": "Могила",
                  "nameFr": "Mogila"
            },
            {
                  "name": "Negotino",
                  "nameAr": "Преговори",
                  "nameFr": "Negotino"
            },
            {
                  "name": "Novaci",
                  "nameAr": "Новачи",
                  "nameFr": "Novaci"
            },
            {
                  "name": "Novo Selo",
                  "nameAr": "Novo Selo",
                  "nameFr": "Novo Selo"
            },
            {
                  "name": "Ohrid",
                  "nameAr": "Охрид",
                  "nameFr": "Ohrid"
            },
            {
                  "name": "Oslomej ",
                  "nameAr": "Oslomej ",
                  "nameFr": "Oslomej "
            },
            {
                  "name": "Pehčevo",
                  "nameAr": "Пехев",
                  "nameFr": "Pehčevo"
            },
            {
                  "name": "Petrovec",
                  "nameAr": "Петровец",
                  "nameFr": "Petrovec"
            },
            {
                  "name": "Plasnica",
                  "nameAr": "Пласканица",
                  "nameFr": "Plasnica"
            },
            {
                  "name": "Prilep",
                  "nameAr": "Прилеп",
                  "nameFr": "Prilep"
            },
            {
                  "name": "Probištip",
                  "nameAr": "Проба",
                  "nameFr": "Probištip"
            },
            {
                  "name": "Radoviš",
                  "nameAr": "Радови",
                  "nameFr": "Radoviš"
            },
            {
                  "name": "Rankovce",
                  "nameAr": "Ранговце",
                  "nameFr": "Rankovce"
            },
            {
                  "name": "Resen",
                  "nameAr": "Сериозно",
                  "nameFr": "Resen"
            },
            {
                  "name": "Rosoman",
                  "nameAr": "Rosoman",
                  "nameFr": "Rosoman"
            },
            {
                  "name": "Saraj",
                  "nameAr": "Сераглио",
                  "nameFr": "Saraj"
            },
            {
                  "name": "Sopište",
                  "nameAr": "Sopište",
                  "nameFr": "Sopište"
            },
            {
                  "name": "Staro Nagoričane",
                  "nameAr": "Стари Нагорици",
                  "nameFr": "Staro Nagoričane"
            },
            {
                  "name": "Štip",
                  "nameAr": "Брод",
                  "nameFr": "Štip"
            },
            {
                  "name": "Struga",
                  "nameAr": "Поток",
                  "nameFr": "Struga"
            },
            {
                  "name": "Strumica",
                  "nameAr": "Струмика",
                  "nameFr": "Strumica"
            },
            {
                  "name": "Studeničani",
                  "nameAr": "Студијани",
                  "nameFr": "Studeničani"
            },
            {
                  "name": "Šuto Orizari",
                  "nameAr": "Тивок Оризари",
                  "nameFr": "Šuto Orizari"
            },
            {
                  "name": "Sveti Nikole",
                  "nameAr": "Свети Никола",
                  "nameFr": "Sveti Nikole"
            },
            {
                  "name": "Tearce",
                  "nameAr": "Солза",
                  "nameFr": "Tearce"
            },
            {
                  "name": "Tetovo",
                  "nameAr": "Тетово",
                  "nameFr": "Tetovo"
            },
            {
                  "name": "Valandovo",
                  "nameAr": "Валандово",
                  "nameFr": "Valandovo"
            },
            {
                  "name": "Vasilevo",
                  "nameAr": "Василево",
                  "nameFr": "Vasilevo"
            },
            {
                  "name": "Veles",
                  "nameAr": "Велес",
                  "nameFr": "Veles"
            },
            {
                  "name": "Vevčani",
                  "nameAr": "Трговија",
                  "nameFr": "Vevčani"
            },
            {
                  "name": "Vinica",
                  "nameAr": "Виника",
                  "nameFr": "Vinica"
            },
            {
                  "name": "Vraneštica",
                  "nameAr": "Vraneštica",
                  "nameFr": "Vraneštica"
            },
            {
                  "name": "Vrapčište",
                  "nameAr": "Sparpage",
                  "nameFr": "Vrapčište"
            },
            {
                  "name": "Zajas",
                  "nameAr": "Зајас",
                  "nameFr": "Zajas"
            },
            {
                  "name": "Zelenikovo",
                  "nameAr": "Zelenikovo",
                  "nameFr": "Zelenikovo"
            },
            {
                  "name": "Želino",
                  "nameAr": "Желе",
                  "nameFr": "Želino"
            },
            {
                  "name": "Zrnovci",
                  "nameAr": "Zrnovec",
                  "nameFr": "Zrnovci"
            }
      ]
  },
  {
    "code": "NO",
    "name": "Norway",
    "nameAr": "النرويج",
    "nameFr": "Norway",
    "cities": [
            {
                  "name": "Agder",
                  "nameAr": "Agder",
                  "nameFr": "Agder"
            },
            {
                  "name": "Akershus",
                  "nameAr": "Akershus",
                  "nameFr": "Akershus"
            },
            {
                  "name": "Buskerud",
                  "nameAr": "Buskerud",
                  "nameFr": "Buskerud"
            },
            {
                  "name": "Finnmark",
                  "nameAr": "Finnmark",
                  "nameFr": "Finnmark"
            },
            {
                  "name": "Innlandet",
                  "nameAr": "Innlandet",
                  "nameFr": "Innlandet"
            },
            {
                  "name": "Jan Mayen",
                  "nameAr": "Jan Mayen",
                  "nameFr": "Jan Mayen"
            },
            {
                  "name": "Møre og Romsdal",
                  "nameAr": "Møre og Romsdal",
                  "nameFr": "Møre og Romsdal"
            },
            {
                  "name": "Nordland",
                  "nameAr": "Nordland",
                  "nameFr": "Nordland"
            },
            {
                  "name": "Oslo",
                  "nameAr": "Oslo",
                  "nameFr": "Oslo"
            },
            {
                  "name": "Østfold",
                  "nameAr": "Østfold",
                  "nameFr": "Østfold"
            },
            {
                  "name": "Rogaland",
                  "nameAr": "Rogaland",
                  "nameFr": "Rogaland"
            },
            {
                  "name": "Svalbard",
                  "nameAr": "Svalbard",
                  "nameFr": "Svalbard"
            },
            {
                  "name": "Telemark",
                  "nameAr": "Telemark",
                  "nameFr": "Telemark"
            },
            {
                  "name": "Troms",
                  "nameAr": "Troms",
                  "nameFr": "Troms"
            },
            {
                  "name": "Trøndelag",
                  "nameAr": "Trøndelag",
                  "nameFr": "Trøndelag"
            },
            {
                  "name": "Vestfold",
                  "nameAr": "Vestfold",
                  "nameFr": "Vestfold"
            },
            {
                  "name": "Vestland",
                  "nameAr": "Vestland",
                  "nameFr": "Vestland"
            }
      ]
  },
  {
    "code": "PL",
    "name": "Poland",
    "nameAr": "بولندا",
    "nameFr": "Poland",
    "cities": [
            {
                  "name": "Greater Poland",
                  "nameAr": "Większa Polska",
                  "nameFr": "Greater Poland"
            },
            {
                  "name": "Holy Cross",
                  "nameAr": "Święty krzyż",
                  "nameFr": "Holy Cross"
            },
            {
                  "name": "Kuyavia-Pomerania",
                  "nameAr": "Kuyavia-Pomerania",
                  "nameFr": "Kuyavia-Pomerania"
            },
            {
                  "name": "Lesser Poland",
                  "nameAr": "Mniejsza Polska",
                  "nameFr": "Lesser Poland"
            },
            {
                  "name": "Lower Silesia",
                  "nameAr": "Dolna Śląska",
                  "nameFr": "Lower Silesia"
            },
            {
                  "name": "Lublin",
                  "nameAr": "Lublin",
                  "nameFr": "Lublin"
            },
            {
                  "name": "Lubusz",
                  "nameAr": "Lubus",
                  "nameFr": "Lubusz"
            },
            {
                  "name": "Łódź",
                  "nameAr": "Łódź",
                  "nameFr": "Łódź"
            },
            {
                  "name": "Mazovia",
                  "nameAr": "Mazovia",
                  "nameFr": "Mazovia"
            },
            {
                  "name": "Podlaskie",
                  "nameAr": "Podlaskie",
                  "nameFr": "Podlaskie"
            },
            {
                  "name": "Pomerania",
                  "nameAr": "Pomerania",
                  "nameFr": "Pomerania"
            },
            {
                  "name": "Silesia",
                  "nameAr": "Śląska",
                  "nameFr": "Silesia"
            },
            {
                  "name": "Subcarpathia",
                  "nameAr": "Sub -Carpathia",
                  "nameFr": "Subcarpathia"
            },
            {
                  "name": "Upper Silesia",
                  "nameAr": "Upper Silesia",
                  "nameFr": "Upper Silesia"
            },
            {
                  "name": "Warmia-Masuria",
                  "nameAr": "Warmia-Masuria",
                  "nameFr": "Warmia-Masuria"
            },
            {
                  "name": "West Pomerania",
                  "nameAr": "West Pomerania",
                  "nameFr": "West Pomerania"
            }
      ]
  },
  {
    "code": "PT",
    "name": "Portugal",
    "nameAr": "البرتغال",
    "nameFr": "Portugal",
    "cities": [
            {
                  "name": "Açores",
                  "nameAr": "Açores",
                  "nameFr": "Açores"
            },
            {
                  "name": "Aveiro",
                  "nameAr": "Aveiro",
                  "nameFr": "Aveiro"
            },
            {
                  "name": "Beja",
                  "nameAr": "Beja",
                  "nameFr": "Beja"
            },
            {
                  "name": "Braga",
                  "nameAr": "Braga",
                  "nameFr": "Braga"
            },
            {
                  "name": "Bragança",
                  "nameAr": "Bragança",
                  "nameFr": "Bragança"
            },
            {
                  "name": "Castelo Branco",
                  "nameAr": "Castelo Branco",
                  "nameFr": "Castelo Branco"
            },
            {
                  "name": "Coimbra",
                  "nameAr": "Coimbra",
                  "nameFr": "Coimbra"
            },
            {
                  "name": "Évora",
                  "nameAr": "Évora",
                  "nameFr": "Évora"
            },
            {
                  "name": "Faro",
                  "nameAr": "Faro",
                  "nameFr": "Faro"
            },
            {
                  "name": "Guarda",
                  "nameAr": "Guarda",
                  "nameFr": "Guarda"
            },
            {
                  "name": "Leiria",
                  "nameAr": "Leiria",
                  "nameFr": "Leiria"
            },
            {
                  "name": "Lisbon",
                  "nameAr": "Lisbon",
                  "nameFr": "Lisbon"
            },
            {
                  "name": "Madeira",
                  "nameAr": "Madeira",
                  "nameFr": "Madeira"
            },
            {
                  "name": "Portalegre",
                  "nameAr": "Portalegre",
                  "nameFr": "Portalegre"
            },
            {
                  "name": "Porto",
                  "nameAr": "Porto",
                  "nameFr": "Porto"
            },
            {
                  "name": "Santarém",
                  "nameAr": "Santarém",
                  "nameFr": "Santarém"
            },
            {
                  "name": "Setúbal",
                  "nameAr": "Setúbal",
                  "nameFr": "Setúbal"
            },
            {
                  "name": "Viana do Castelo",
                  "nameAr": "Viana do Castelo",
                  "nameFr": "Viana do Castelo"
            },
            {
                  "name": "Vila Real",
                  "nameAr": "Vila Real",
                  "nameFr": "Vila Real"
            },
            {
                  "name": "Viseu",
                  "nameAr": "Viseu",
                  "nameFr": "Viseu"
            }
      ]
  },
  {
    "code": "RO",
    "name": "Romania",
    "nameAr": "رومانيا",
    "nameFr": "Romania",
    "cities": [
            {
                  "name": "Alba",
                  "nameAr": "Alba",
                  "nameFr": "Alba"
            },
            {
                  "name": "Arad",
                  "nameAr": "Arad",
                  "nameFr": "Arad"
            },
            {
                  "name": "Arges",
                  "nameAr": "Arges",
                  "nameFr": "Arges"
            },
            {
                  "name": "Bacău",
                  "nameAr": "Bacău",
                  "nameFr": "Bacău"
            },
            {
                  "name": "Bihor",
                  "nameAr": "Bihor",
                  "nameFr": "Bihor"
            },
            {
                  "name": "Bistrița-Năsăud",
                  "nameAr": "Bistrița-Năsăud",
                  "nameFr": "Bistrița-Năsăud"
            },
            {
                  "name": "Botoșani",
                  "nameAr": "Botoșani",
                  "nameFr": "Botoșani"
            },
            {
                  "name": "Braila",
                  "nameAr": "Braila",
                  "nameFr": "Braila"
            },
            {
                  "name": "Brașov",
                  "nameAr": "Brașov",
                  "nameFr": "Brașov"
            },
            {
                  "name": "Bucharest",
                  "nameAr": "Bucureşti",
                  "nameFr": "Bucharest"
            },
            {
                  "name": "Buzău",
                  "nameAr": "Buzău",
                  "nameFr": "Buzău"
            },
            {
                  "name": "Călărași",
                  "nameAr": "Călărași",
                  "nameFr": "Călărași"
            },
            {
                  "name": "Caraș-Severin",
                  "nameAr": "Caraș-Severin",
                  "nameFr": "Caraș-Severin"
            },
            {
                  "name": "Cluj",
                  "nameAr": "Cluj",
                  "nameFr": "Cluj"
            },
            {
                  "name": "Constanța",
                  "nameAr": "Constanța",
                  "nameFr": "Constanța"
            },
            {
                  "name": "Covasna",
                  "nameAr": "Covasna",
                  "nameFr": "Covasna"
            },
            {
                  "name": "Dâmbovița",
                  "nameAr": "Dâmbovița",
                  "nameFr": "Dâmbovița"
            },
            {
                  "name": "Dolj",
                  "nameAr": "Dolj",
                  "nameFr": "Dolj"
            },
            {
                  "name": "Galați",
                  "nameAr": "Galați",
                  "nameFr": "Galați"
            },
            {
                  "name": "Giurgiu",
                  "nameAr": "Giurgiu",
                  "nameFr": "Giurgiu"
            },
            {
                  "name": "Gorj",
                  "nameAr": "Gorj",
                  "nameFr": "Gorj"
            },
            {
                  "name": "Harghita",
                  "nameAr": "Harghita",
                  "nameFr": "Harghita"
            },
            {
                  "name": "Hunedoara",
                  "nameAr": "Hunedoara",
                  "nameFr": "Hunedoara"
            },
            {
                  "name": "Ialomița",
                  "nameAr": "Ialomița",
                  "nameFr": "Ialomița"
            },
            {
                  "name": "Iași",
                  "nameAr": "Iași",
                  "nameFr": "Iași"
            },
            {
                  "name": "Ilfov",
                  "nameAr": "Ilfov",
                  "nameFr": "Ilfov"
            },
            {
                  "name": "Maramureș",
                  "nameAr": "Maramureș",
                  "nameFr": "Maramureș"
            },
            {
                  "name": "Mehedinți",
                  "nameAr": "Mehedinți",
                  "nameFr": "Mehedinți"
            },
            {
                  "name": "Mureș",
                  "nameAr": "Mureș",
                  "nameFr": "Mureș"
            },
            {
                  "name": "Neamț",
                  "nameAr": "Neamț",
                  "nameFr": "Neamț"
            },
            {
                  "name": "Olt",
                  "nameAr": "Olt",
                  "nameFr": "Olt"
            },
            {
                  "name": "Prahova",
                  "nameAr": "Prahova",
                  "nameFr": "Prahova"
            },
            {
                  "name": "Sălaj",
                  "nameAr": "Sălaj",
                  "nameFr": "Sălaj"
            },
            {
                  "name": "Satu Mare",
                  "nameAr": "O iapă",
                  "nameFr": "Satu Mare"
            },
            {
                  "name": "Sibiu",
                  "nameAr": "Sibiu",
                  "nameFr": "Sibiu"
            },
            {
                  "name": "Suceava",
                  "nameAr": "Suceava",
                  "nameFr": "Suceava"
            },
            {
                  "name": "Teleorman",
                  "nameAr": "Teleorman",
                  "nameFr": "Teleorman"
            },
            {
                  "name": "Timiș",
                  "nameAr": "Timiș",
                  "nameFr": "Timiș"
            },
            {
                  "name": "Tulcea",
                  "nameAr": "Tulcea",
                  "nameFr": "Tulcea"
            },
            {
                  "name": "Vâlcea",
                  "nameAr": "Vâlcea",
                  "nameFr": "Vâlcea"
            },
            {
                  "name": "Vaslui",
                  "nameAr": "Vaslui",
                  "nameFr": "Vaslui"
            },
            {
                  "name": "Vrancea",
                  "nameAr": "Vrancea",
                  "nameFr": "Vrancea"
            }
      ]
  },
  {
    "code": "RU",
    "name": "Russia",
    "nameAr": "روسيا",
    "nameFr": "Russia",
    "cities": [
            {
                  "name": "Adygea",
                  "nameAr": "Adygea",
                  "nameFr": "Adygea"
            },
            {
                  "name": "Altai",
                  "nameAr": "Алтай",
                  "nameFr": "Altai"
            },
            {
                  "name": "Altai",
                  "nameAr": "Алтай",
                  "nameFr": "Altai"
            },
            {
                  "name": "Amur",
                  "nameAr": "Амур",
                  "nameFr": "Amur"
            },
            {
                  "name": "Arkhangelsk",
                  "nameAr": "Лист",
                  "nameFr": "Arkhangelsk"
            },
            {
                  "name": "Astrakhan",
                  "nameAr": "Астрахан",
                  "nameFr": "Astrakhan"
            },
            {
                  "name": "Bashkortostan",
                  "nameAr": "Башкорторстн",
                  "nameFr": "Bashkortostan"
            },
            {
                  "name": "Belgorod",
                  "nameAr": "Bellarod",
                  "nameFr": "Belgorod"
            },
            {
                  "name": "Bryansk",
                  "nameAr": "Брайанск",
                  "nameFr": "Bryansk"
            },
            {
                  "name": "Buryatia",
                  "nameAr": "Buryatia",
                  "nameFr": "Buryatia"
            },
            {
                  "name": "Chechen",
                  "nameAr": "Чеченский",
                  "nameFr": "Chechen"
            },
            {
                  "name": "Chelyabinsk",
                  "nameAr": "Челлиабинск",
                  "nameFr": "Chelyabinsk"
            },
            {
                  "name": "Chukotka",
                  "nameAr": "Чукотка",
                  "nameFr": "Chukotka"
            },
            {
                  "name": "Chuvash",
                  "nameAr": "Чуваш",
                  "nameFr": "Chuvash"
            },
            {
                  "name": "Dagestan",
                  "nameAr": "Дагестан",
                  "nameFr": "Dagestan"
            },
            {
                  "name": "Ingushetia",
                  "nameAr": "Inguhetia",
                  "nameFr": "Ingushetia"
            },
            {
                  "name": "Irkutsk",
                  "nameAr": "Irkutsk",
                  "nameFr": "Irkutsk"
            },
            {
                  "name": "Ivanovo",
                  "nameAr": "Иваново",
                  "nameFr": "Ivanovo"
            },
            {
                  "name": "Jewish",
                  "nameAr": "Еврейский",
                  "nameFr": "Jewish"
            },
            {
                  "name": "Kabardino-Balkar",
                  "nameAr": "Кабардино-Балкар",
                  "nameFr": "Kabardino-Balkar"
            },
            {
                  "name": "Kaliningrad",
                  "nameAr": "Калининград",
                  "nameFr": "Kaliningrad"
            },
            {
                  "name": "Kalmykia",
                  "nameAr": "Калмикия",
                  "nameFr": "Kalmykia"
            },
            {
                  "name": "Kaluga",
                  "nameAr": "Клуб",
                  "nameFr": "Kaluga"
            },
            {
                  "name": "Kamchatka",
                  "nameAr": "Камчатка",
                  "nameFr": "Kamchatka"
            },
            {
                  "name": "Karachay-Cherkess",
                  "nameAr": "Карачай-Черкесс",
                  "nameFr": "Karachay-Cherkess"
            },
            {
                  "name": "Karelia",
                  "nameAr": "Карелия",
                  "nameFr": "Karelia"
            },
            {
                  "name": "Kemerovo",
                  "nameAr": "Кемерово",
                  "nameFr": "Kemerovo"
            },
            {
                  "name": "Khabarovsk",
                  "nameAr": "Хабаровск",
                  "nameFr": "Khabarovsk"
            },
            {
                  "name": "Khakassia",
                  "nameAr": "Хаммассия",
                  "nameFr": "Khakassia"
            },
            {
                  "name": "Khanty-Mansi",
                  "nameAr": "Khanty-Mansi",
                  "nameFr": "Khanty-Mansi"
            },
            {
                  "name": "Kirov",
                  "nameAr": "Киров",
                  "nameFr": "Kirov"
            },
            {
                  "name": "Komi",
                  "nameAr": "Посещение",
                  "nameFr": "Komi"
            },
            {
                  "name": "Kostroma",
                  "nameAr": "Кострома",
                  "nameFr": "Kostroma"
            },
            {
                  "name": "Krasnodar",
                  "nameAr": "Краснодар",
                  "nameFr": "Krasnodar"
            },
            {
                  "name": "Krasnoyarsk",
                  "nameAr": "Krasnoyarsk",
                  "nameFr": "Krasnoyarsk"
            },
            {
                  "name": "Kurgan",
                  "nameAr": "Курган",
                  "nameFr": "Kurgan"
            },
            {
                  "name": "Kursk",
                  "nameAr": "Курск",
                  "nameFr": "Kursk"
            },
            {
                  "name": "Leningrad",
                  "nameAr": "Ленинград",
                  "nameFr": "Leningrad"
            },
            {
                  "name": "Lipetsk",
                  "nameAr": "Липетск",
                  "nameFr": "Lipetsk"
            },
            {
                  "name": "Magadan",
                  "nameAr": "Виндада",
                  "nameFr": "Magadan"
            },
            {
                  "name": "Mari El",
                  "nameAr": "Мари Эль",
                  "nameFr": "Mari El"
            },
            {
                  "name": "Mordovia",
                  "nameAr": "Мордовия",
                  "nameFr": "Mordovia"
            },
            {
                  "name": "Moscow",
                  "nameAr": "Москва",
                  "nameFr": "Moscow"
            },
            {
                  "name": "Moscow",
                  "nameAr": "Москва",
                  "nameFr": "Moscow"
            },
            {
                  "name": "Murmansk",
                  "nameAr": "Мурманск",
                  "nameFr": "Murmansk"
            },
            {
                  "name": "Nenets",
                  "nameAr": "Ненетс",
                  "nameFr": "Nenets"
            },
            {
                  "name": "Nizhny Novgorod",
                  "nameAr": "Нижни Новгород",
                  "nameFr": "Nizhny Novgorod"
            },
            {
                  "name": "North Ossetia-Alania",
                  "nameAr": "Северная Осетия-Алания",
                  "nameFr": "North Ossetia-Alania"
            },
            {
                  "name": "Novgorod",
                  "nameAr": "Новгород",
                  "nameFr": "Novgorod"
            },
            {
                  "name": "Novosibirsk",
                  "nameAr": "Новосибирск",
                  "nameFr": "Novosibirsk"
            },
            {
                  "name": "Omsk",
                  "nameAr": "Omsk",
                  "nameFr": "Omsk"
            },
            {
                  "name": "Orenburg",
                  "nameAr": "Оренбург",
                  "nameFr": "Orenburg"
            },
            {
                  "name": "Oryol",
                  "nameAr": "Ирил",
                  "nameFr": "Oryol"
            },
            {
                  "name": "Penza",
                  "nameAr": "Действительно",
                  "nameFr": "Penza"
            },
            {
                  "name": "Perm",
                  "nameAr": "Перми",
                  "nameFr": "Perm"
            },
            {
                  "name": "Primorsky",
                  "nameAr": "ПРИМОРСКИЙ",
                  "nameFr": "Primorsky"
            },
            {
                  "name": "Pskov",
                  "nameAr": "ПСКОВ",
                  "nameFr": "Pskov"
            },
            {
                  "name": "Rostov",
                  "nameAr": "Росток",
                  "nameFr": "Rostov"
            },
            {
                  "name": "Ryazan",
                  "nameAr": "Рьязан",
                  "nameFr": "Ryazan"
            },
            {
                  "name": "Saint Petersburg",
                  "nameAr": "Сент -Петербург",
                  "nameFr": "Saint Petersburg"
            },
            {
                  "name": "Sakha",
                  "nameAr": "Мы строим",
                  "nameFr": "Sakha"
            },
            {
                  "name": "Sakhalin",
                  "nameAr": "Sakhalin",
                  "nameFr": "Sakhalin"
            },
            {
                  "name": "Samara",
                  "nameAr": "Самара",
                  "nameFr": "Samara"
            },
            {
                  "name": "Saratov",
                  "nameAr": "Saratov",
                  "nameFr": "Saratov"
            },
            {
                  "name": "Smolensk",
                  "nameAr": "Смоленск",
                  "nameFr": "Smolensk"
            },
            {
                  "name": "Stavropol",
                  "nameAr": "Stavropol",
                  "nameFr": "Stavropol"
            },
            {
                  "name": "Sverdlovsk",
                  "nameAr": "Свердловск",
                  "nameFr": "Sverdlovsk"
            },
            {
                  "name": "Tambov",
                  "nameAr": "Тамбов",
                  "nameFr": "Tambov"
            },
            {
                  "name": "Tatarstan",
                  "nameAr": "Tatarstan",
                  "nameFr": "Tatarstan"
            },
            {
                  "name": "Tomsk",
                  "nameAr": "Топливать",
                  "nameFr": "Tomsk"
            },
            {
                  "name": "Tula",
                  "nameAr": "Тула",
                  "nameFr": "Tula"
            },
            {
                  "name": "Tuva",
                  "nameAr": "Закрывать",
                  "nameFr": "Tuva"
            },
            {
                  "name": "Tver",
                  "nameAr": "Захватывать",
                  "nameFr": "Tver"
            },
            {
                  "name": "Tyumen",
                  "nameAr": "Ужесточить",
                  "nameFr": "Tyumen"
            },
            {
                  "name": "Udmurt",
                  "nameAr": "Удмурт",
                  "nameFr": "Udmurt"
            },
            {
                  "name": "Ulyanovsk",
                  "nameAr": "Ulyanovsk",
                  "nameFr": "Ulyanovsk"
            },
            {
                  "name": "Vladimir",
                  "nameAr": "Владимир",
                  "nameFr": "Vladimir"
            },
            {
                  "name": "Volgograd Oblast",
                  "nameAr": "Volgograd Oblast",
                  "nameFr": "Volgograd Oblast"
            },
            {
                  "name": "Vologda",
                  "nameAr": "Vanogda",
                  "nameFr": "Vologda"
            },
            {
                  "name": "Voronezh",
                  "nameAr": "Воронж",
                  "nameFr": "Voronezh"
            },
            {
                  "name": "Yamalo-Nenets",
                  "nameAr": "Ямало-Ненеты",
                  "nameFr": "Yamalo-Nenets"
            },
            {
                  "name": "Yaroslavl",
                  "nameAr": "Ярославл",
                  "nameFr": "Yaroslavl"
            },
            {
                  "name": "Zabaykalsky",
                  "nameAr": "Забайкальский",
                  "nameFr": "Zabaykalsky"
            }
      ]
  },
  {
    "code": "SM",
    "name": "San Marino",
    "nameAr": "سان مارينو",
    "nameFr": "San Marino",
    "cities": [
            {
                  "name": "Acquaviva",
                  "nameAr": "Acquaviva",
                  "nameFr": "Acquaviva"
            },
            {
                  "name": "Borgo Maggiore",
                  "nameAr": "Borgo Maggiore",
                  "nameFr": "Borgo Maggiore"
            },
            {
                  "name": "Chiesanuova",
                  "nameAr": "Chiesanuova",
                  "nameFr": "Chiesanuova"
            },
            {
                  "name": "Domagnano",
                  "nameAr": "Domagnano",
                  "nameFr": "Domagnano"
            },
            {
                  "name": "Faetano",
                  "nameAr": "Condizione",
                  "nameFr": "Faetano"
            },
            {
                  "name": "Fiorentino",
                  "nameAr": "Fiorentino",
                  "nameFr": "Fiorentino"
            },
            {
                  "name": "Montegiardino",
                  "nameAr": "Montegiardino",
                  "nameFr": "Montegiardino"
            },
            {
                  "name": "San Marino",
                  "nameAr": "San Marino",
                  "nameFr": "San Marino"
            },
            {
                  "name": "Serravalle",
                  "nameAr": "Serravalle",
                  "nameFr": "Serravalle"
            }
      ]
  },
  {
    "code": "RS",
    "name": "Serbia",
    "nameAr": "صربيا",
    "nameFr": "Serbia",
    "cities": [
      {
        "name": "Belgrade",
        "nameAr": "",
        "nameFr": "Belgrade"
      },
      {
        "name": "Bor",
        "nameAr": "",
        "nameFr": "Bor"
      },
      {
        "name": "Braničevo",
        "nameAr": "",
        "nameFr": "Braničevo"
      },
      {
        "name": "Central Banat",
        "nameAr": "",
        "nameFr": "Central Banat"
      },
      {
        "name": "Jablanica",
        "nameAr": "",
        "nameFr": "Jablanica"
      },
      {
        "name": "Kolubara",
        "nameAr": "",
        "nameFr": "Kolubara"
      },
      {
        "name": "Mačva",
        "nameAr": "",
        "nameFr": "Mačva"
      },
      {
        "name": "Moravica",
        "nameAr": "",
        "nameFr": "Moravica"
      },
      {
        "name": "Nišava",
        "nameAr": "",
        "nameFr": "Nišava"
      },
      {
        "name": "North Bačka",
        "nameAr": "",
        "nameFr": "North Bačka"
      },
      {
        "name": "North Banat",
        "nameAr": "",
        "nameFr": "North Banat"
      },
      {
        "name": "Pčinja",
        "nameAr": "",
        "nameFr": "Pčinja"
      },
      {
        "name": "Pirot",
        "nameAr": "",
        "nameFr": "Pirot"
      },
      {
        "name": "Podunavlje",
        "nameAr": "",
        "nameFr": "Podunavlje"
      },
      {
        "name": "Pomoravlje",
        "nameAr": "",
        "nameFr": "Pomoravlje"
      },
      {
        "name": "Rasina",
        "nameAr": "",
        "nameFr": "Rasina"
      },
      {
        "name": "Raška",
        "nameAr": "",
        "nameFr": "Raška"
      },
      {
        "name": "South Bačka",
        "nameAr": "",
        "nameFr": "South Bačka"
      },
      {
        "name": "South Banat",
        "nameAr": "",
        "nameFr": "South Banat"
      },
      {
        "name": "Srem",
        "nameAr": "",
        "nameFr": "Srem"
      },
      {
        "name": "Šumadija",
        "nameAr": "",
        "nameFr": "Šumadija"
      },
      {
        "name": "Toplica",
        "nameAr": "",
        "nameFr": "Toplica"
      },
      {
        "name": "Vojvodina",
        "nameAr": "",
        "nameFr": "Vojvodina"
      },
      {
        "name": "West Bačka",
        "nameAr": "",
        "nameFr": "West Bačka"
      },
      {
        "name": "Zaječar",
        "nameAr": "",
        "nameFr": "Zaječar"
      },
      {
        "name": "Zlatibor",
        "nameAr": "",
        "nameFr": "Zlatibor"
      }
    ]
  },
  {
    "code": "SK",
    "name": "Slovakia",
    "nameAr": "سلوفاكيا",
    "nameFr": "Slovakia",
    "cities": [
            {
                  "name": "Banská Bystrica",
                  "nameAr": "Banská Bystrica",
                  "nameFr": "Banská Bystrica"
            },
            {
                  "name": "Bratislava",
                  "nameAr": "Bratislava",
                  "nameFr": "Bratislava"
            },
            {
                  "name": "Košice",
                  "nameAr": "Košice",
                  "nameFr": "Košice"
            },
            {
                  "name": "Nitra",
                  "nameAr": "Nitra",
                  "nameFr": "Nitra"
            },
            {
                  "name": "Prešov",
                  "nameAr": "Prešov",
                  "nameFr": "Prešov"
            },
            {
                  "name": "Trenčín",
                  "nameAr": "Trenčín",
                  "nameFr": "Trenčín"
            },
            {
                  "name": "Trnava",
                  "nameAr": "Trnava",
                  "nameFr": "Trnava"
            },
            {
                  "name": "Žilina",
                  "nameAr": "Žilina",
                  "nameFr": "Žilina"
            }
      ]
  },
  {
    "code": "SI",
    "name": "Slovenia",
    "nameAr": "سلوفينيا",
    "nameFr": "Slovenia",
    "cities": [
            {
                  "name": "Ajdovščina",
                  "nameAr": "Ajdovščina",
                  "nameFr": "Ajdovščina"
            },
            {
                  "name": "Ankaran",
                  "nameAr": "Ankaran",
                  "nameFr": "Ankaran"
            },
            {
                  "name": "Apače",
                  "nameAr": "Apače",
                  "nameFr": "Apače"
            },
            {
                  "name": "Beltinci",
                  "nameAr": "Beltinci",
                  "nameFr": "Beltinci"
            },
            {
                  "name": "Benedikt",
                  "nameAr": "Benedikt",
                  "nameFr": "Benedikt"
            },
            {
                  "name": "Bistrica ob Sotli",
                  "nameAr": "Bistrica ob Sotli",
                  "nameFr": "Bistrica ob Sotli"
            },
            {
                  "name": "Bled",
                  "nameAr": "Meledo",
                  "nameFr": "Bled"
            },
            {
                  "name": "Bloke",
                  "nameAr": "Bloke",
                  "nameFr": "Bloke"
            },
            {
                  "name": "Bohinj",
                  "nameAr": "Bohinj",
                  "nameFr": "Bohinj"
            },
            {
                  "name": "Borovnica",
                  "nameAr": "Borovnica",
                  "nameFr": "Borovnica"
            },
            {
                  "name": "Bovec",
                  "nameAr": "Bovec",
                  "nameFr": "Bovec"
            },
            {
                  "name": "Braslovče",
                  "nameAr": "Braslovče",
                  "nameFr": "Braslovče"
            },
            {
                  "name": "Brda",
                  "nameAr": "Hribi",
                  "nameFr": "Brda"
            },
            {
                  "name": "Brežice",
                  "nameAr": "Brežice",
                  "nameFr": "Brežice"
            },
            {
                  "name": "Brezovica",
                  "nameAr": "Brezovica",
                  "nameFr": "Brezovica"
            },
            {
                  "name": "Cankova",
                  "nameAr": "Cankova",
                  "nameFr": "Cankova"
            },
            {
                  "name": "Celje",
                  "nameAr": "Celje",
                  "nameFr": "Celje"
            },
            {
                  "name": "Cerklje na Gorenjskem",
                  "nameAr": "Cerklje na Gorenjskem",
                  "nameFr": "Cerklje na Gorenjskem"
            },
            {
                  "name": "Cerknica",
                  "nameAr": "Cerknica",
                  "nameFr": "Cerknica"
            },
            {
                  "name": "Cerkno",
                  "nameAr": "Cerkno",
                  "nameFr": "Cerkno"
            },
            {
                  "name": "Cerkvenjak",
                  "nameAr": "Cerkvenjak",
                  "nameFr": "Cerkvenjak"
            },
            {
                  "name": "Cirkulane",
                  "nameAr": "Cirkulane",
                  "nameFr": "Cirkulane"
            },
            {
                  "name": "Črenšovci",
                  "nameAr": "Črenšovci",
                  "nameFr": "Črenšovci"
            },
            {
                  "name": "Črna na Koroškem",
                  "nameAr": "Črna na Koroškem",
                  "nameFr": "Črna na Koroškem"
            },
            {
                  "name": "Črnomelj",
                  "nameAr": "Črnomelj",
                  "nameFr": "Črnomelj"
            },
            {
                  "name": "Destrnik",
                  "nameAr": "Destrnik",
                  "nameFr": "Destrnik"
            },
            {
                  "name": "Divača",
                  "nameAr": "Reduktor",
                  "nameFr": "Divača"
            },
            {
                  "name": "Dobje",
                  "nameAr": "Dobje",
                  "nameFr": "Dobje"
            },
            {
                  "name": "Dobrepolje",
                  "nameAr": "Dobrepolje",
                  "nameFr": "Dobrepolje"
            },
            {
                  "name": "Dobrna",
                  "nameAr": "Dobrna",
                  "nameFr": "Dobrna"
            },
            {
                  "name": "Dobrova–Polhov Gradec",
                  "nameAr": "Dobrova–Polhov Gradec",
                  "nameFr": "Dobrova–Polhov Gradec"
            },
            {
                  "name": "Dobrovnik",
                  "nameAr": "Dobrovnik",
                  "nameFr": "Dobrovnik"
            },
            {
                  "name": "Dol pri Ljubljani",
                  "nameAr": "Dol pri Ljubljani",
                  "nameFr": "Dol pri Ljubljani"
            },
            {
                  "name": "Dolenjske Toplice",
                  "nameAr": "Dolenjske Toplice",
                  "nameFr": "Dolenjske Toplice"
            },
            {
                  "name": "Domžale",
                  "nameAr": "Domžale",
                  "nameFr": "Domžale"
            },
            {
                  "name": "Dornava",
                  "nameAr": "Dornava",
                  "nameFr": "Dornava"
            },
            {
                  "name": "Dravograd",
                  "nameAr": "Dravograd",
                  "nameFr": "Dravograd"
            },
            {
                  "name": "Duplek",
                  "nameAr": "Duplek",
                  "nameFr": "Duplek"
            },
            {
                  "name": "Gorenja Vas–Poljane",
                  "nameAr": "Zažgal te -fell",
                  "nameFr": "Gorenja Vas–Poljane"
            },
            {
                  "name": "Gorišnica",
                  "nameAr": "Gorišnica",
                  "nameFr": "Gorišnica"
            },
            {
                  "name": "Gorje",
                  "nameAr": "Gorje",
                  "nameFr": "Gorje"
            },
            {
                  "name": "Gornja Radgona",
                  "nameAr": "Gornja Radgona",
                  "nameFr": "Gornja Radgona"
            },
            {
                  "name": "Gornji Grad",
                  "nameAr": "Gornji Grad",
                  "nameFr": "Gornji Grad"
            },
            {
                  "name": "Gornji Petrovci",
                  "nameAr": "Gornji Petrovci",
                  "nameFr": "Gornji Petrovci"
            },
            {
                  "name": "Grad",
                  "nameAr": "Grad",
                  "nameFr": "Grad"
            },
            {
                  "name": "Grosuplje",
                  "nameAr": "Grosuplje",
                  "nameFr": "Grosuplje"
            },
            {
                  "name": "Hajdina",
                  "nameAr": "Hajdina",
                  "nameFr": "Hajdina"
            },
            {
                  "name": "Hoče–Slivnica",
                  "nameAr": "Hoče–Slivnica",
                  "nameFr": "Hoče–Slivnica"
            },
            {
                  "name": "Hodoš",
                  "nameAr": "Hodoš",
                  "nameFr": "Hodoš"
            },
            {
                  "name": "Horjul",
                  "nameAr": "Horjul",
                  "nameFr": "Horjul"
            },
            {
                  "name": "Hrastnik",
                  "nameAr": "Hrastnik",
                  "nameFr": "Hrastnik"
            },
            {
                  "name": "Hrpelje–Kozina",
                  "nameAr": "Hrpelje–Kozina",
                  "nameFr": "Hrpelje–Kozina"
            },
            {
                  "name": "Idrija",
                  "nameAr": "Idrija",
                  "nameFr": "Idrija"
            },
            {
                  "name": "Ig",
                  "nameAr": "Ig",
                  "nameFr": "Ig"
            },
            {
                  "name": "Ilirska Bistrica",
                  "nameAr": "Ilirska Bistrica",
                  "nameFr": "Ilirska Bistrica"
            },
            {
                  "name": "Ivančna Gorica",
                  "nameAr": "Ivančna Gorica",
                  "nameFr": "Ivančna Gorica"
            },
            {
                  "name": "Izola",
                  "nameAr": "Izola",
                  "nameFr": "Izola"
            },
            {
                  "name": "Jesenice",
                  "nameAr": "Jesenice",
                  "nameFr": "Jesenice"
            },
            {
                  "name": "Jezersko",
                  "nameAr": "Jezersko",
                  "nameFr": "Jezersko"
            },
            {
                  "name": "Juršinci",
                  "nameAr": "Juršinci",
                  "nameFr": "Juršinci"
            },
            {
                  "name": "Kamnik",
                  "nameAr": "Kamnik",
                  "nameFr": "Kamnik"
            },
            {
                  "name": "Kanal ob Soči",
                  "nameAr": "Kanal ob Soči",
                  "nameFr": "Kanal ob Soči"
            },
            {
                  "name": "Kidričevo",
                  "nameAr": "Kidričevo",
                  "nameFr": "Kidričevo"
            },
            {
                  "name": "Kobarid",
                  "nameAr": "Kobarid",
                  "nameFr": "Kobarid"
            },
            {
                  "name": "Kobilje",
                  "nameAr": "Kobilje",
                  "nameFr": "Kobilje"
            },
            {
                  "name": "Kočevje",
                  "nameAr": "Kočevje",
                  "nameFr": "Kočevje"
            },
            {
                  "name": "Komen",
                  "nameAr": "Pridi",
                  "nameFr": "Komen"
            },
            {
                  "name": "Komenda",
                  "nameAr": "Ukaz",
                  "nameFr": "Komenda"
            },
            {
                  "name": "Koper",
                  "nameAr": "Baker",
                  "nameFr": "Koper"
            },
            {
                  "name": "Kostanjevica na Krki",
                  "nameAr": "Kostanjevica na Krki",
                  "nameFr": "Kostanjevica na Krki"
            },
            {
                  "name": "Kostel",
                  "nameAr": "Cerkev",
                  "nameFr": "Kostel"
            },
            {
                  "name": "Kozje",
                  "nameAr": "Kozje",
                  "nameFr": "Kozje"
            },
            {
                  "name": "Kranj",
                  "nameAr": "Kranj",
                  "nameFr": "Kranj"
            },
            {
                  "name": "Kranjska Gora",
                  "nameAr": "Kranjska Gora",
                  "nameFr": "Kranjska Gora"
            },
            {
                  "name": "Križevci",
                  "nameAr": "Križevci",
                  "nameFr": "Križevci"
            },
            {
                  "name": "Krško",
                  "nameAr": "Krško",
                  "nameFr": "Krško"
            },
            {
                  "name": "Kungota",
                  "nameAr": "Kungota",
                  "nameFr": "Kungota"
            },
            {
                  "name": "Kuzma",
                  "nameAr": "Kuzma",
                  "nameFr": "Kuzma"
            },
            {
                  "name": "Laško",
                  "nameAr": "Laško",
                  "nameFr": "Laško"
            },
            {
                  "name": "Lenart",
                  "nameAr": "Lenart",
                  "nameFr": "Lenart"
            },
            {
                  "name": "Lendava",
                  "nameAr": "Lendava",
                  "nameFr": "Lendava"
            },
            {
                  "name": "Litija",
                  "nameAr": "Litij",
                  "nameFr": "Litija"
            },
            {
                  "name": "Ljubljana",
                  "nameAr": "LJUBLANA",
                  "nameFr": "Ljubljana"
            },
            {
                  "name": "Ljubno",
                  "nameAr": "Ljubno",
                  "nameFr": "Ljubno"
            },
            {
                  "name": "Ljutomer",
                  "nameAr": "Ljutomer",
                  "nameFr": "Ljutomer"
            },
            {
                  "name": "Log–Dragomer",
                  "nameAr": "Log–Dragomer",
                  "nameFr": "Log–Dragomer"
            },
            {
                  "name": "Logatec",
                  "nameAr": "Logatec",
                  "nameFr": "Logatec"
            },
            {
                  "name": "Loška Dolina",
                  "nameAr": "Loška Dolina",
                  "nameFr": "Loška Dolina"
            },
            {
                  "name": "Loški Potok",
                  "nameAr": "Loški Potok",
                  "nameFr": "Loški Potok"
            },
            {
                  "name": "Lovrenc na Pohorju",
                  "nameAr": "Lovrenc na Pohorju",
                  "nameFr": "Lovrenc na Pohorju"
            },
            {
                  "name": "Luče",
                  "nameAr": "Luč",
                  "nameFr": "Luče"
            },
            {
                  "name": "Lukovica",
                  "nameAr": "Lukovica",
                  "nameFr": "Lukovica"
            },
            {
                  "name": "Majšperk",
                  "nameAr": "Majšperk",
                  "nameFr": "Majšperk"
            },
            {
                  "name": "Makole",
                  "nameAr": "Makole",
                  "nameFr": "Makole"
            },
            {
                  "name": "Maribor",
                  "nameAr": "Maribor",
                  "nameFr": "Maribor"
            },
            {
                  "name": "Markovci",
                  "nameAr": "Markovci",
                  "nameFr": "Markovci"
            },
            {
                  "name": "Medvode",
                  "nameAr": "Medvode",
                  "nameFr": "Medvode"
            },
            {
                  "name": "Mengeš",
                  "nameAr": "Mengeš",
                  "nameFr": "Mengeš"
            },
            {
                  "name": "Metlika",
                  "nameAr": "Metlika",
                  "nameFr": "Metlika"
            },
            {
                  "name": "Mežica",
                  "nameAr": "Mežica",
                  "nameFr": "Mežica"
            },
            {
                  "name": "Miklavž na Dravskem Polju",
                  "nameAr": "Miklavž na Dravskem Polju",
                  "nameFr": "Miklavž na Dravskem Polju"
            },
            {
                  "name": "Miren–Kostanjevica",
                  "nameAr": "Miren–Kostanjevica",
                  "nameFr": "Miren–Kostanjevica"
            },
            {
                  "name": "Mirna",
                  "nameAr": "MiRNA",
                  "nameFr": "Mirna"
            },
            {
                  "name": "Mirna Peč",
                  "nameAr": "Mirna Peč",
                  "nameFr": "Mirna Peč"
            },
            {
                  "name": "Mislinja",
                  "nameAr": "Mislinja",
                  "nameFr": "Mislinja"
            },
            {
                  "name": "Mokronog–Trebelno",
                  "nameAr": "Mokronog–Trebelno",
                  "nameFr": "Mokronog–Trebelno"
            },
            {
                  "name": "Moravče",
                  "nameAr": "Moravče",
                  "nameFr": "Moravče"
            },
            {
                  "name": "Moravske Toplice",
                  "nameAr": "Moravske Toplice",
                  "nameFr": "Moravske Toplice"
            },
            {
                  "name": "Mozirje",
                  "nameAr": "Mozirje",
                  "nameFr": "Mozirje"
            },
            {
                  "name": "Murska Sobota",
                  "nameAr": "Murska Sobota",
                  "nameFr": "Murska Sobota"
            },
            {
                  "name": "Muta",
                  "nameAr": "Muta",
                  "nameFr": "Muta"
            },
            {
                  "name": "Naklo",
                  "nameAr": "Naklo",
                  "nameFr": "Naklo"
            },
            {
                  "name": "Nazarje",
                  "nameAr": "Nazarje",
                  "nameFr": "Nazarje"
            },
            {
                  "name": "Nova Gorica",
                  "nameAr": "Nova Gorica",
                  "nameFr": "Nova Gorica"
            },
            {
                  "name": "Novo Mesto",
                  "nameAr": "Novo Mesto",
                  "nameFr": "Novo Mesto"
            },
            {
                  "name": "Odranci",
                  "nameAr": "Odranci",
                  "nameFr": "Odranci"
            },
            {
                  "name": "Oplotnica",
                  "nameAr": "Oplotnica",
                  "nameFr": "Oplotnica"
            },
            {
                  "name": "Ormož",
                  "nameAr": "Ormož",
                  "nameFr": "Ormož"
            },
            {
                  "name": "Osilnica",
                  "nameAr": "Osilnica",
                  "nameFr": "Osilnica"
            },
            {
                  "name": "Pesnica",
                  "nameAr": "Pesnica",
                  "nameFr": "Pesnica"
            },
            {
                  "name": "Piran",
                  "nameAr": "Piran",
                  "nameFr": "Piran"
            },
            {
                  "name": "Pivka",
                  "nameAr": "Pivka",
                  "nameFr": "Pivka"
            },
            {
                  "name": "Podčetrtek",
                  "nameAr": "Podčetrtek",
                  "nameFr": "Podčetrtek"
            },
            {
                  "name": "Podlehnik",
                  "nameAr": "Podlehnik",
                  "nameFr": "Podlehnik"
            },
            {
                  "name": "Podvelka",
                  "nameAr": "Podvelka",
                  "nameFr": "Podvelka"
            },
            {
                  "name": "Poljčane",
                  "nameAr": "Poljčane",
                  "nameFr": "Poljčane"
            },
            {
                  "name": "Polzela",
                  "nameAr": "Polzela",
                  "nameFr": "Polzela"
            },
            {
                  "name": "Postojna",
                  "nameAr": "Postojna",
                  "nameFr": "Postojna"
            },
            {
                  "name": "Prebold",
                  "nameAr": "Prebold",
                  "nameFr": "Prebold"
            },
            {
                  "name": "Preddvor",
                  "nameAr": "Preddvor",
                  "nameFr": "Preddvor"
            },
            {
                  "name": "Prevalje",
                  "nameAr": "Prevalje",
                  "nameFr": "Prevalje"
            },
            {
                  "name": "Ptuj",
                  "nameAr": "Ptuj",
                  "nameFr": "Ptuj"
            },
            {
                  "name": "Puconci",
                  "nameAr": "Puconci",
                  "nameFr": "Puconci"
            },
            {
                  "name": "Rače–Fram",
                  "nameAr": "Rače–Fram",
                  "nameFr": "Rače–Fram"
            },
            {
                  "name": "Radeče",
                  "nameAr": "Radeče",
                  "nameFr": "Radeče"
            },
            {
                  "name": "Radenci",
                  "nameAr": "Radenci",
                  "nameFr": "Radenci"
            },
            {
                  "name": "Radlje ob Dravi",
                  "nameAr": "Radlje ob Dravi",
                  "nameFr": "Radlje ob Dravi"
            },
            {
                  "name": "Radovljica",
                  "nameAr": "Radovljica",
                  "nameFr": "Radovljica"
            },
            {
                  "name": "Ravne na Koroškem",
                  "nameAr": "Ravne na Koroškem",
                  "nameFr": "Ravne na Koroškem"
            },
            {
                  "name": "Razkrižje",
                  "nameAr": "Razkrižje",
                  "nameFr": "Razkrižje"
            },
            {
                  "name": "Rečica ob Savinji",
                  "nameAr": "Rečica ob Savinji",
                  "nameFr": "Rečica ob Savinji"
            },
            {
                  "name": "Renče–Vogrsko",
                  "nameAr": "Renče–Vogrsko",
                  "nameFr": "Renče–Vogrsko"
            },
            {
                  "name": "Ribnica",
                  "nameAr": "Ribnica",
                  "nameFr": "Ribnica"
            },
            {
                  "name": "Ribnica na Pohorju",
                  "nameAr": "Ribnica na Pohorju",
                  "nameFr": "Ribnica na Pohorju"
            },
            {
                  "name": "Rogaška Slatina",
                  "nameAr": "Rogaška Slatina",
                  "nameFr": "Rogaška Slatina"
            },
            {
                  "name": "Rogašovci",
                  "nameAr": "Rogašovci",
                  "nameFr": "Rogašovci"
            },
            {
                  "name": "Rogatec",
                  "nameAr": "Rogatec",
                  "nameFr": "Rogatec"
            },
            {
                  "name": "Ruše",
                  "nameAr": "Ruševine",
                  "nameFr": "Ruše"
            },
            {
                  "name": "Šalovci",
                  "nameAr": "Šalovci",
                  "nameFr": "Šalovci"
            },
            {
                  "name": "Selnica ob Dravi",
                  "nameAr": "Selnica ob Dravi",
                  "nameFr": "Selnica ob Dravi"
            },
            {
                  "name": "Semič",
                  "nameAr": "Semič",
                  "nameFr": "Semič"
            },
            {
                  "name": "Šempeter–Vrtojba",
                  "nameAr": "Šempeter–Vrtojba",
                  "nameFr": "Šempeter–Vrtojba"
            },
            {
                  "name": "Šenčur",
                  "nameAr": "Šenčur",
                  "nameFr": "Šenčur"
            },
            {
                  "name": "Šentilj",
                  "nameAr": "Šentilj",
                  "nameFr": "Šentilj"
            },
            {
                  "name": "Šentjernej",
                  "nameAr": "Šentjernej",
                  "nameFr": "Šentjernej"
            },
            {
                  "name": "Šentjur",
                  "nameAr": "Šentjur",
                  "nameFr": "Šentjur"
            },
            {
                  "name": "Šentrupert",
                  "nameAr": "Šentrupert",
                  "nameFr": "Šentrupert"
            },
            {
                  "name": "Sevnica",
                  "nameAr": "Sevnica",
                  "nameFr": "Sevnica"
            },
            {
                  "name": "Sežana",
                  "nameAr": "Sežana",
                  "nameFr": "Sežana"
            },
            {
                  "name": "Škocjan",
                  "nameAr": "Škocjan",
                  "nameFr": "Škocjan"
            },
            {
                  "name": "Škofja Loka",
                  "nameAr": "Škofja Loka",
                  "nameFr": "Škofja Loka"
            },
            {
                  "name": "Škofljica",
                  "nameAr": "Škofljica",
                  "nameFr": "Škofljica"
            },
            {
                  "name": "Slovenj Gradec",
                  "nameAr": "Slovenj Gradec",
                  "nameFr": "Slovenj Gradec"
            },
            {
                  "name": "Slovenska Bistrica",
                  "nameAr": "Slovenska Bistrica",
                  "nameFr": "Slovenska Bistrica"
            },
            {
                  "name": "Slovenske Konjice",
                  "nameAr": "Slovenske Konjice",
                  "nameFr": "Slovenske Konjice"
            },
            {
                  "name": "Šmarje pri Jelšah",
                  "nameAr": "Šmarje pri Jelšah",
                  "nameFr": "Šmarje pri Jelšah"
            },
            {
                  "name": "Šmarješke Toplice",
                  "nameAr": "Šmarješke Toplice",
                  "nameFr": "Šmarješke Toplice"
            },
            {
                  "name": "Šmartno ob Paki",
                  "nameAr": "Šmartno ob Paki",
                  "nameFr": "Šmartno ob Paki"
            },
            {
                  "name": "Šmartno pri Litiji",
                  "nameAr": "Šmartno pri Litiji",
                  "nameFr": "Šmartno pri Litiji"
            },
            {
                  "name": "Sodražica",
                  "nameAr": "Sodražica",
                  "nameFr": "Sodražica"
            },
            {
                  "name": "Solčava",
                  "nameAr": "Solčava",
                  "nameFr": "Solčava"
            },
            {
                  "name": "Šoštanj",
                  "nameAr": "Šoštanj",
                  "nameFr": "Šoštanj"
            },
            {
                  "name": "Središče ob Dravi",
                  "nameAr": "Središče ob Dravi",
                  "nameFr": "Središče ob Dravi"
            },
            {
                  "name": "Starše",
                  "nameAr": "Starše",
                  "nameFr": "Starše"
            },
            {
                  "name": "Štore",
                  "nameAr": "Štore",
                  "nameFr": "Štore"
            },
            {
                  "name": "Straža",
                  "nameAr": "Straža",
                  "nameFr": "Straža"
            },
            {
                  "name": "Sveta Ana",
                  "nameAr": "Sveta ana",
                  "nameFr": "Sveta Ana"
            },
            {
                  "name": "Sveta Trojica v Slovenskih Goricah",
                  "nameAr": "Sveta Trojica v Slovenskih Goricah",
                  "nameFr": "Sveta Trojica v Slovenskih Goricah"
            },
            {
                  "name": "Sveti Andraž v Slovenskih Goricah",
                  "nameAr": "Sveti Andraž v Slovenskih Goricah",
                  "nameFr": "Sveti Andraž v Slovenskih Goricah"
            },
            {
                  "name": "Sveti Jurij ob Ščavnici",
                  "nameAr": "Sveti Jurij ob Ščavnici",
                  "nameFr": "Sveti Jurij ob Ščavnici"
            },
            {
                  "name": "Sveti Jurij v Slovenskih Goricah",
                  "nameAr": "Sveti Jurij v Slovenskih Goricah",
                  "nameFr": "Sveti Jurij v Slovenskih Goricah"
            },
            {
                  "name": "Sveti Tomaž",
                  "nameAr": "Sveti Tomaž",
                  "nameFr": "Sveti Tomaž"
            },
            {
                  "name": "Tabor",
                  "nameAr": "Tabor",
                  "nameFr": "Tabor"
            },
            {
                  "name": "Tišina",
                  "nameAr": "Tišina",
                  "nameFr": "Tišina"
            },
            {
                  "name": "Tolmin",
                  "nameAr": "Tolmin",
                  "nameFr": "Tolmin"
            },
            {
                  "name": "Trbovlje",
                  "nameAr": "Trbovlje",
                  "nameFr": "Trbovlje"
            },
            {
                  "name": "Trebnje",
                  "nameAr": "Trebnje",
                  "nameFr": "Trebnje"
            },
            {
                  "name": "Trnovska Vas",
                  "nameAr": "Trnovska Vas",
                  "nameFr": "Trnovska Vas"
            },
            {
                  "name": "Tržič",
                  "nameAr": "Tržič",
                  "nameFr": "Tržič"
            },
            {
                  "name": "Trzin",
                  "nameAr": "Trzin",
                  "nameFr": "Trzin"
            },
            {
                  "name": "Turnišče",
                  "nameAr": "Turnišče",
                  "nameFr": "Turnišče"
            },
            {
                  "name": "Velika Polana",
                  "nameAr": "Velika Polana",
                  "nameFr": "Velika Polana"
            },
            {
                  "name": "Velike Lašče",
                  "nameAr": "Velike Lašče",
                  "nameFr": "Velike Lašče"
            },
            {
                  "name": "Veržej",
                  "nameAr": "Veržej",
                  "nameFr": "Veržej"
            },
            {
                  "name": "Videm",
                  "nameAr": "Videm",
                  "nameFr": "Videm"
            },
            {
                  "name": "Vipava",
                  "nameAr": "Vipava",
                  "nameFr": "Vipava"
            },
            {
                  "name": "Vitanje",
                  "nameAr": "Vitanje",
                  "nameFr": "Vitanje"
            },
            {
                  "name": "Vodice",
                  "nameAr": "Vodice",
                  "nameFr": "Vodice"
            },
            {
                  "name": "Vojnik",
                  "nameAr": "Vojak",
                  "nameFr": "Vojnik"
            },
            {
                  "name": "Vransko",
                  "nameAr": "Vransko",
                  "nameFr": "Vransko"
            },
            {
                  "name": "Vrhnika",
                  "nameAr": "Vrhnika",
                  "nameFr": "Vrhnika"
            },
            {
                  "name": "Vuzenica",
                  "nameAr": "Vuzenica",
                  "nameFr": "Vuzenica"
            },
            {
                  "name": "Zagorje ob Savi",
                  "nameAr": "Zagorje ob Savi",
                  "nameFr": "Zagorje ob Savi"
            },
            {
                  "name": "Žalec",
                  "nameAr": "Žalec",
                  "nameFr": "Žalec"
            },
            {
                  "name": "Zavrč",
                  "nameAr": "Zavrč",
                  "nameFr": "Zavrč"
            },
            {
                  "name": "Železniki",
                  "nameAr": "Železniki",
                  "nameFr": "Železniki"
            },
            {
                  "name": "Žetale",
                  "nameAr": "Žetale",
                  "nameFr": "Žetale"
            },
            {
                  "name": "Žiri",
                  "nameAr": "Porota",
                  "nameFr": "Žiri"
            },
            {
                  "name": "Žirovnica",
                  "nameAr": "Žirovnica",
                  "nameFr": "Žirovnica"
            },
            {
                  "name": "Zreče",
                  "nameAr": "Zreče",
                  "nameFr": "Zreče"
            },
            {
                  "name": "Žužemberk",
                  "nameAr": "Žužemberk",
                  "nameFr": "Žužemberk"
            }
      ]
  },
  {
    "code": "ES",
    "name": "Spain",
    "nameAr": "إسبانيا",
    "nameFr": "Spain",
    "cities": [
      {
        "name": "Aragon",
        "nameAr": "أراغون",
        "nameFr": "Aragon"
      },
      {
        "name": "Galicia",
        "nameAr": "غاليسيا",
        "nameFr": "Galice"
      },
      {
        "name": "Castilla y Leon",
        "nameAr": "كاستيا ي ليون",
        "nameFr": "Castille et Leon"
      },
      {
        "name": "Extremadura",
        "nameAr": "إكستريمادورا",
        "nameFr": "Estrémadure"
      },
      {
        "name": "Pais Vasco",
        "nameAr": "بايس فاسكو",
        "nameFr": "Pais Vasco"
      },
      {
        "name": "Cantabria",
        "nameAr": "كانتابريا",
        "nameFr": "Cantabrie"
      },
      {
        "name": "Navarra",
        "nameAr": "نافارا",
        "nameFr": "Navarre"
      },
      {
        "name": "Asturias",
        "nameAr": "أستورياس",
        "nameFr": "Asturies"
      },
      {
        "name": "La Rioja",
        "nameAr": "لا ريوخا",
        "nameFr": "La Rioja"
      },
      {
        "name": "Castilla-La Mancha",
        "nameAr": "كاستيا لا مانشا",
        "nameFr": "Castilla-La Mancha"
      },
      {
        "name": "Murcia",
        "nameAr": "مورسيا",
        "nameFr": "Murcie"
      },
      {
        "name": "Andalucia",
        "nameAr": "الأندلس",
        "nameFr": "Andalousie"
      },
      {
        "name": "Comunidad Valenciana",
        "nameAr": "Comunidad فالنسيانا",
        "nameFr": "Comunidad Valenciana"
      },
      {
        "name": "Catalonia",
        "nameAr": "كاتالونيا",
        "nameFr": "Catalogne"
      },
      {
        "name": "Canarias",
        "nameAr": "جزر الكناري",
        "nameFr": "Canarias"
      },
      {
        "name": "Madrid",
        "nameAr": "مدريد",
        "nameFr": "Madrid"
      },
      {
        "name": "Islas Baleares",
        "nameAr": "ايسلاس باليريس",
        "nameFr": "Islas Baleares"
      }
    ]
  },
  {
    "code": "SJ",
    "name": "Svalbard and Jan Mayen Islands",
    "nameAr": "سفالبارد وجان ماين",
    "nameFr": "Svalbard and Jan Mayen Islands",
    "cities": []
  },
  {
    "code": "SE",
    "name": "Sweden",
    "nameAr": "السويد",
    "nameFr": "Sweden",
    "cities": [
            {
                  "name": "Blekinge",
                  "nameAr": "Blekinge",
                  "nameFr": "Blekinge"
            },
            {
                  "name": "Dalarna",
                  "nameAr": "Dalarna",
                  "nameFr": "Dalarna"
            },
            {
                  "name": "Gävleborg",
                  "nameAr": "Gävleborg",
                  "nameFr": "Gävleborg"
            },
            {
                  "name": "Gotland",
                  "nameAr": "Gotland",
                  "nameFr": "Gotland"
            },
            {
                  "name": "Halland",
                  "nameAr": "Halland",
                  "nameFr": "Halland"
            },
            {
                  "name": "Jämtland",
                  "nameAr": "Jämtland",
                  "nameFr": "Jämtland"
            },
            {
                  "name": "Jönköping",
                  "nameAr": "Jönköping",
                  "nameFr": "Jönköping"
            },
            {
                  "name": "Kalmar",
                  "nameAr": "Kalmar",
                  "nameFr": "Kalmar"
            },
            {
                  "name": "Kronoberg",
                  "nameAr": "Kronoberg",
                  "nameFr": "Kronoberg"
            },
            {
                  "name": "Norrbotten",
                  "nameAr": "Norrbotten",
                  "nameFr": "Norrbotten"
            },
            {
                  "name": "Örebro",
                  "nameAr": "Örebro",
                  "nameFr": "Örebro"
            },
            {
                  "name": "Östergötland",
                  "nameAr": "Östergötland",
                  "nameFr": "Östergötland"
            },
            {
                  "name": "Skåne",
                  "nameAr": "Skåne",
                  "nameFr": "Skåne"
            },
            {
                  "name": "Södermanland",
                  "nameAr": "Södermanland",
                  "nameFr": "Södermanland"
            },
            {
                  "name": "Stockholm",
                  "nameAr": "Stockholm",
                  "nameFr": "Stockholm"
            },
            {
                  "name": "Uppsala",
                  "nameAr": "Uppsala",
                  "nameFr": "Uppsala"
            },
            {
                  "name": "Värmland",
                  "nameAr": "Värmland",
                  "nameFr": "Värmland"
            },
            {
                  "name": "Västerbotten",
                  "nameAr": "Västerbotten",
                  "nameFr": "Västerbotten"
            },
            {
                  "name": "Västernorrland",
                  "nameAr": "Västernorrland",
                  "nameFr": "Västernorrland"
            },
            {
                  "name": "Västmanland",
                  "nameAr": "Västmanland",
                  "nameFr": "Västmanland"
            },
            {
                  "name": "Västra Götaland",
                  "nameAr": "Västra Götaland",
                  "nameFr": "Västra Götaland"
            }
      ]
  },
  {
    "code": "CH",
    "name": "Switzerland",
    "nameAr": "سويسرا",
    "nameFr": "Switzerland",
    "cities": [
      {
        "name": "Thurgau",
        "nameAr": "ثورجو",
        "nameFr": "Thurgovie"
      },
      {
        "name": "Aargau",
        "nameAr": "أرجاو",
        "nameFr": "Argovie"
      },
      {
        "name": "Bern",
        "nameAr": "برن",
        "nameFr": "Berne"
      },
      {
        "name": "Zurich",
        "nameAr": "زيوريخ",
        "nameFr": "Zurich"
      },
      {
        "name": "Fribourg",
        "nameAr": "فريبورغ",
        "nameFr": "Fribourg"
      },
      {
        "name": "Ausser-Rhoden",
        "nameAr": "Ausser-رودين",
        "nameFr": "Ausser-Rhoden"
      },
      {
        "name": "Valais",
        "nameAr": "فاليه",
        "nameFr": "Valais"
      },
      {
        "name": "Uri",
        "nameAr": "أوري",
        "nameFr": "Uri"
      },
      {
        "name": "Graubunden",
        "nameAr": "غراوبوندن",
        "nameFr": "Les Grisons"
      },
      {
        "name": "Ticino",
        "nameAr": "تيسان",
        "nameFr": "Tessin"
      },
      {
        "name": "Luzern",
        "nameAr": "لوزيرن",
        "nameFr": "Lucerne"
      },
      {
        "name": "Obwalden",
        "nameAr": "أوبوالدن",
        "nameFr": "Obwalden"
      },
      {
        "name": "Solothurn",
        "nameAr": "سولوتورن",
        "nameFr": "Soleure"
      },
      {
        "name": "Basel-Stadt",
        "nameAr": "بازل شتات",
        "nameFr": "Bâle-Ville"
      },
      {
        "name": "Inner-Rhoden",
        "nameAr": "الداخلية-رودين",
        "nameFr": "Rhodes-Intérieures"
      },
      {
        "name": "Zug",
        "nameAr": "زوغ",
        "nameFr": "Zoug"
      },
      {
        "name": "Vaud",
        "nameAr": "فو",
        "nameFr": "Vaud"
      },
      {
        "name": "Jura",
        "nameAr": "العصر الجوارسي أو الجوري",
        "nameFr": "Jura"
      },
      {
        "name": "Basel-Landschaft",
        "nameAr": "كانتون ريف بازل",
        "nameFr": "Bâle-Campagne"
      },
      {
        "name": "Schwyz",
        "nameAr": "شفيتس",
        "nameFr": "Schwyz"
      },
      {
        "name": "Sankt Gallen",
        "nameAr": "سانكت غالن",
        "nameFr": "Saint-Gall"
      },
      {
        "name": "Schaffhausen",
        "nameAr": "شافهاوزن",
        "nameFr": "Schaffhouse"
      },
      {
        "name": "Glarus",
        "nameAr": "جلاروس",
        "nameFr": "Glaris"
      },
      {
        "name": "Geneve",
        "nameAr": "جنيف",
        "nameFr": "Geneve"
      },
      {
        "name": "Neuchatel",
        "nameAr": "نيوشاتل",
        "nameFr": "Neuchâtel"
      },
      {
        "name": "Nidwalden",
        "nameAr": "نيدوالدن",
        "nameFr": "Nidwalden"
      }
    ]
  },
  {
    "code": "UA",
    "name": "Ukraine",
    "nameAr": "أوكرانيا",
    "nameFr": "Ukraine",
    "cities": [
            {
                  "name": "Autonomous Republic of Crimea",
                  "nameAr": "Автономна Республіка Криму",
                  "nameFr": "Autonomous Republic of Crimea"
            },
            {
                  "name": "Cherkaska",
                  "nameAr": "Черкаска",
                  "nameFr": "Cherkaska"
            },
            {
                  "name": "Chernihivska",
                  "nameAr": "Chernihivska",
                  "nameFr": "Chernihivska"
            },
            {
                  "name": "Chernivetska",
                  "nameAr": "Chernivetska",
                  "nameFr": "Chernivetska"
            },
            {
                  "name": "Dnipropetrovska",
                  "nameAr": "Дніпропетровська",
                  "nameFr": "Dnipropetrovska"
            },
            {
                  "name": "Donetska",
                  "nameAr": "Donetska",
                  "nameFr": "Donetska"
            },
            {
                  "name": "Ivano-Frankivska",
                  "nameAr": "Ivano-Frankivska",
                  "nameFr": "Ivano-Frankivska"
            },
            {
                  "name": "Kharkivska",
                  "nameAr": "Kharkivska",
                  "nameFr": "Kharkivska"
            },
            {
                  "name": "Khersonska",
                  "nameAr": "Херсонська",
                  "nameFr": "Khersonska"
            },
            {
                  "name": "Khmelnytska",
                  "nameAr": "Кхмельняцька",
                  "nameFr": "Khmelnytska"
            },
            {
                  "name": "Kirovohradska",
                  "nameAr": "Kirovohradska",
                  "nameFr": "Kirovohradska"
            },
            {
                  "name": "Kyiv",
                  "nameAr": "Києв",
                  "nameFr": "Kyiv"
            },
            {
                  "name": "Kyivska",
                  "nameAr": "Київська",
                  "nameFr": "Kyivska"
            },
            {
                  "name": "Luhanska",
                  "nameAr": "Luhanska",
                  "nameFr": "Luhanska"
            },
            {
                  "name": "Lvivska",
                  "nameAr": "Lvivska",
                  "nameFr": "Lvivska"
            },
            {
                  "name": "Mykolaivska",
                  "nameAr": "Mykolaivska",
                  "nameFr": "Mykolaivska"
            },
            {
                  "name": "Odeska",
                  "nameAr": "Odeska",
                  "nameFr": "Odeska"
            },
            {
                  "name": "Poltavska",
                  "nameAr": "Poltavska",
                  "nameFr": "Poltavska"
            },
            {
                  "name": "Rivnenska",
                  "nameAr": "Рівненська",
                  "nameFr": "Rivnenska"
            },
            {
                  "name": "Sevastopol",
                  "nameAr": "Севастополь",
                  "nameFr": "Sevastopol"
            },
            {
                  "name": "Sumska",
                  "nameAr": "Підозра",
                  "nameFr": "Sumska"
            },
            {
                  "name": "Ternopilska",
                  "nameAr": "Ternopilska",
                  "nameFr": "Ternopilska"
            },
            {
                  "name": "Vinnytska",
                  "nameAr": "Вінникка",
                  "nameFr": "Vinnytska"
            },
            {
                  "name": "Volynska",
                  "nameAr": "Волонська",
                  "nameFr": "Volynska"
            },
            {
                  "name": "Zakarpatska",
                  "nameAr": "Закарпака",
                  "nameFr": "Zakarpatska"
            },
            {
                  "name": "Zaporizka",
                  "nameAr": "Zaporizka",
                  "nameFr": "Zaporizka"
            },
            {
                  "name": "Zhytomyrska",
                  "nameAr": "Чжітоміка",
                  "nameFr": "Zhytomyrska"
            }
      ]
  },
  {
    "code": "GB",
    "name": "United Kingdom",
    "nameAr": "المملكة المتحدة",
    "nameFr": "United Kingdom",
    "cities": [
      {
        "name": "Worcestershire",
        "nameAr": "رسيستيرشاير",
        "nameFr": "Worcestershire"
      },
      {
        "name": "Hampshire",
        "nameAr": "هامبشاير",
        "nameFr": "Hampshire"
      },
      {
        "name": "Herefordshire",
        "nameAr": "هرفوردشير",
        "nameFr": "Herefordshire"
      },
      {
        "name": "Essex",
        "nameAr": "إسيكس",
        "nameFr": "Essex"
      },
      {
        "name": "Powys",
        "nameAr": "بوويز",
        "nameFr": "Powys"
      },
      {
        "name": "Monmouthshire",
        "nameAr": "مونماوثشاير",
        "nameFr": "Monmouthshire"
      },
      {
        "name": "Scottish Borders",
        "nameAr": "الحدود الاسكتلندية",
        "nameFr": "Scottish Borders"
      },
      {
        "name": "Cumbria",
        "nameAr": "كمبريا",
        "nameFr": "Cumbria"
      },
      {
        "name": "Devon",
        "nameAr": "ديفون",
        "nameFr": "Devon"
      },
      {
        "name": "Staffordshire",
        "nameAr": "ستافوردشاير",
        "nameFr": "Staffordshire"
      },
      {
        "name": "Dorset",
        "nameAr": "دورست",
        "nameFr": "Dorset"
      },
      {
        "name": "Hertford",
        "nameAr": "هيرتفورد",
        "nameFr": "Hertford"
      },
      {
        "name": "Cambridgeshire",
        "nameAr": "كامبريدج",
        "nameFr": "Cambridgeshire"
      },
      {
        "name": "Lancashire",
        "nameAr": "لانكشاير",
        "nameFr": "Lancashire"
      },
      {
        "name": "Conwy",
        "nameAr": "كونوي",
        "nameFr": "Conwy"
      },
      {
        "name": "Ceredigion",
        "nameAr": "سرديجون",
        "nameFr": "Ceredigion"
      },
      {
        "name": "Rhondda Cynon Taff",
        "nameAr": "روندا سينون تاف",
        "nameFr": "Rhondda Cynon Taff"
      },
      {
        "name": "Highland",
        "nameAr": "هضبة",
        "nameFr": "Montagnes"
      },
      {
        "name": "Perth and Kinross",
        "nameAr": "بيرث و كينروس",
        "nameFr": "Perth et Kinross"
      },
      {
        "name": "Caerphilly",
        "nameAr": "كيرفيلي",
        "nameFr": "Caerphilly"
      },
      {
        "name": "Blaenau Gwent",
        "nameAr": "Blaenau Gwent",
        "nameFr": "Blaenau Gwent"
      },
      {
        "name": "Merthyr Tydfil",
        "nameAr": "ميرثير تيدفيل",
        "nameFr": "Merthyr Tydfil"
      },
      {
        "name": "Pembrokeshire",
        "nameAr": "بيمبروكشاير",
        "nameFr": "Pembrokeshire"
      },
      {
        "name": "Aberdeenshire",
        "nameAr": "أبردينشاير",
        "nameFr": "Aberdeenshire"
      },
      {
        "name": "Gwynedd",
        "nameAr": "جويند",
        "nameFr": "Gwynedd"
      },
      {
        "name": "Aberdeen City",
        "nameAr": "مدينة أبردين",
        "nameFr": "Aberdeen City"
      },
      {
        "name": "Fife",
        "nameAr": "ناي آلة موسيقية",
        "nameFr": "Fifre"
      },
      {
        "name": "Neath Port Talbot",
        "nameAr": "نيث بورت تالبوت",
        "nameFr": "Neath Port Talbot"
      },
      {
        "name": "Wokingham",
        "nameAr": "ووكينغهام",
        "nameFr": "Wokingham"
      },
      {
        "name": "York",
        "nameAr": "يورك",
        "nameFr": "York"
      },
      {
        "name": "Stirling",
        "nameAr": "ستيرلينغ",
        "nameFr": "Stirling"
      },
      {
        "name": "Carmarthenshire",
        "nameAr": "كرمرثنشير",
        "nameFr": "Carmarthenshire"
      },
      {
        "name": "Bridgend",
        "nameAr": "كارديف",
        "nameFr": "Bridgend"
      },
      {
        "name": "East Lothian",
        "nameAr": "شرق لوثيان",
        "nameFr": "East Lothian"
      },
      {
        "name": "Angus",
        "nameAr": "انجوس",
        "nameFr": "Angus"
      },
      {
        "name": "Moray",
        "nameAr": "موراي",
        "nameFr": "Moray"
      }
    ]
  },
  {
    "code": "VA",
    "name": "Vatican City State (Holy See)",
    "nameAr": "الفاتيكان",
    "nameFr": "Vatican City State (Holy See)",
    "cities": []
  }
];
